// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Ids Button Component CSS
 * (Includes standard and icon button rules)
 */
/**
 * Ids Button Sass mixins, used in Ids Button CSS to define base styles.
 */
/**
 * Provides standardized padding rules for certain button types
 */
/**
 * Provides the standard color rules for all regular buttons
 */
/**
 * Provides the standard color rules for buttons that need box shadow
 */
:host {
  display: inline-flex;
  vertical-align: middle;
}
:host ::slotted(span) {
  vertical-align: bottom;
}
:host ::slotted(span),
:host ::slotted(ids-text) {
  color: currentColor;
  align-self: center;
}
:host ::slotted(ids-icon) {
  vertical-align: middle;
  color: currentColor;
}
:host ::slotted(ids-icon[compact=true]) {
  margin-inline-end: var(--ids-space-2xs);
}
:host ::slotted(span.audible) {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
:host button,
:host .ids-icon-button {
  justify-content: center;
  height: 100%;
  width: 100%;
}

:host(.hidden) {
  display: none;
}

:host([system-button]) button:not(.is-active):hover {
  background-color: var(--ids-color-transparent);
  border-color: var(--ids-color-transparent);
  color: var(--ids-button-system-color-text-hover);
}

:host([hidden]) {
  display: none;
}

button {
  display: block;
}

.ids-button,
.ids-toggle-button,
.ids-menu-button:not(.ids-icon-button),
.ids-modal-button {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ids-button .ids-icon,
.ids-toggle-button .ids-icon,
.ids-menu-button:not(.ids-icon-button) .ids-icon,
.ids-modal-button .ids-icon {
  display: inline-flex;
  place-self: center;
  vertical-align: middle;
}

.ids-button.compact,
.ids-icon-button.compact {
  font-size: var(--ids-font-size-2xs);
  height: var(--ids-button-compact-width);
  line-height: 16px;
}

.ids-button.ellipsis ::slotted(span) {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: inherit;
  height: inherit;
}

.ids-button,
.ids-toggle-button,
.ids-menu-button {
  box-shadow: var(--ids-shadow-none);
  font-weight: var(--ids-font-weight-normal);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
  overflow: hidden;
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
  position: relative;
}
.ids-button, .ids-button::before, .ids-button::after,
.ids-toggle-button,
.ids-toggle-button::before,
.ids-toggle-button::after,
.ids-menu-button,
.ids-menu-button::before,
.ids-menu-button::after {
  box-sizing: border-box;
}
.ids-button *,
.ids-toggle-button *,
.ids-menu-button * {
  pointer-events: none;
}
.ids-button,
.ids-toggle-button,
.ids-menu-button {
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-color-text-default);
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), border-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease), opacity var(--ids-motion-duration) var(--ids-motion-ease);
  white-space: nowrap;
}
.ids-button:focus,
.ids-toggle-button:focus,
.ids-menu-button:focus {
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-button:not([disabled]),
.ids-toggle-button:not([disabled]),
.ids-menu-button:not([disabled]) {
  cursor: var(--ids-cursor-pointer);
}
.ids-button span,
.ids-toggle-button span,
.ids-menu-button span {
  vertical-align: bottom;
}
.ids-button span.audible,
.ids-toggle-button span.audible,
.ids-menu-button span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-button:not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon=genai])),
.ids-toggle-button:not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon=genai])),
.ids-menu-button:not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon=genai])) {
  margin-inline-end: calc(var(--ids-space-2xs) + 3px);
}
.ids-button .ids-icon,
.ids-toggle-button .ids-icon,
.ids-menu-button .ids-icon {
  vertical-align: middle;
}
.ids-button.align-icon-end ::slotted(ids-icon),
.ids-toggle-button.align-icon-end ::slotted(ids-icon),
.ids-menu-button.align-icon-end ::slotted(ids-icon) {
  margin-inline-start: var(--ids-space-2xs);
}
.ids-button.content-align-start,
.ids-toggle-button.content-align-start,
.ids-menu-button.content-align-start {
  justify-content: start;
}
.ids-button.content-align-end,
.ids-toggle-button.content-align-end,
.ids-menu-button.content-align-end {
  justify-content: end;
}
.ids-button.no-margins,
.ids-toggle-button.no-margins,
.ids-menu-button.no-margins {
  margin-inline: var(--ids-space-none);
}
.ids-button.field-height-xxs:not(.btn-secondary):not(.no-margins),
.ids-toggle-button.field-height-xxs:not(.btn-secondary):not(.no-margins),
.ids-menu-button.field-height-xxs:not(.btn-secondary):not(.no-margins) {
  margin-block-start: 3px;
  margin-inline-end: -2px;
  height: 22px;
  width: 22px;
}
.ids-button ::slotted(span),
.ids-toggle-button ::slotted(span),
.ids-menu-button ::slotted(span) {
  font-weight: inherit !important;
}
.ids-button,
.ids-toggle-button,
.ids-menu-button {
  display: inline-flex;
  font-weight: var(--ids-button-tertiary-font-weight);
  border-radius: var(--ids-button-radius);
  background-color: var(--ids-button-tertiary-color-background-default);
  border-color: var(--ids-button-tertiary-color-border-default);
  color: var(--ids-button-tertiary-color-text-default);
}
.ids-button:not(.hide-focus).is-active:not([readonly]), .ids-button:not(.hide-focus).is-focused:not([readonly]), .ids-button:not(.hide-focus):focus:not([readonly]), .ids-button:not(.hide-focus):focus-within:not([readonly]),
.ids-toggle-button:not(.hide-focus).is-active:not([readonly]),
.ids-toggle-button:not(.hide-focus).is-focused:not([readonly]),
.ids-toggle-button:not(.hide-focus):focus:not([readonly]),
.ids-toggle-button:not(.hide-focus):focus-within:not([readonly]),
.ids-menu-button:not(.hide-focus).is-active:not([readonly]),
.ids-menu-button:not(.hide-focus).is-focused:not([readonly]),
.ids-menu-button:not(.hide-focus):focus:not([readonly]),
.ids-menu-button:not(.hide-focus):focus-within:not([readonly]) {
  border-color: var(--ids-button-tertiary-color-border-focus);
}
.ids-button:hover,
.ids-toggle-button:hover,
.ids-menu-button:hover {
  color: var(--ids-button-tertiary-color-text-hover);
  background-color: var(--ids-button-tertiary-color-background-hover);
  border-color: var(--ids-button-tertiary-color-border-hover);
}
.ids-button[disabled],
.ids-toggle-button[disabled],
.ids-menu-button[disabled] {
  color: var(--ids-button-tertiary-color-text-disabled);
  background-color: var(--ids-button-tertiary-color-background-disabled);
  border-color: var(--ids-button-tertiary-color-border-disabled);
  opacity: var(--ids-button-tertiary-opacity-disabled);
}
.ids-button:active:not([disabled]),
.ids-toggle-button:active:not([disabled]),
.ids-menu-button:active:not([disabled]) {
  background-color: var(--ids-button-tertiary-color-background-pressed);
  border-color: var(--ids-button-tertiary-color-border-pressed);
  color: var(--ids-button-tertiary-color-text-pressed);
}
.ids-button.btn-tertiary-destructive,
.ids-toggle-button.btn-tertiary-destructive,
.ids-menu-button.btn-tertiary-destructive {
  background-color: var(--ids-button-destructive-tertiary-color-background-default);
  border-color: var(--ids-button-destructive-tertiary-color-border-default);
  color: var(--ids-button-destructive-tertiary-color-text-default);
}
.ids-button.btn-tertiary-destructive:not(.hide-focus).is-active, .ids-button.btn-tertiary-destructive:not(.hide-focus).is-focused, .ids-button.btn-tertiary-destructive:not(.hide-focus).focus-within, .ids-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-toggle-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-tertiary-color-border-focus);
}
.ids-button.btn-tertiary-destructive:hover,
.ids-toggle-button.btn-tertiary-destructive:hover,
.ids-menu-button.btn-tertiary-destructive:hover {
  background-color: var(--ids-button-destructive-tertiary-color-background-hover);
  border-color: var(--ids-button-destructive-tertiary-color-border-hover);
  color: var(--ids-button-destructive-tertiary-color-text-hover);
}
.ids-button.btn-tertiary-destructive[disabled],
.ids-toggle-button.btn-tertiary-destructive[disabled],
.ids-menu-button.btn-tertiary-destructive[disabled] {
  color: var(--ids-button-destructive-tertiary-color-text-disabled);
  background-color: var(--ids-button-destructive-tertiary-color-background-disabled);
  border-color: var(--ids-button-destructive-tertiary-color-border-disabled);
}
.ids-button.btn-primary,
.ids-toggle-button.btn-primary,
.ids-menu-button.btn-primary {
  background-color: var(--ids-button-primary-color-background-default);
  border-color: var(--ids-button-primary-color-border-default);
  border: 1px solid var(--ids-button-primary-color-border-default);
  color: var(--ids-button-primary-color-text-default);
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
}
.ids-button.btn-primary:not(.hide-focus).is-active, .ids-button.btn-primary:not(.hide-focus).is-focused, .ids-button.btn-primary:not(.hide-focus).focus-within, .ids-button.btn-primary:not(.hide-focus):focus,
.ids-toggle-button.btn-primary:not(.hide-focus).is-active,
.ids-toggle-button.btn-primary:not(.hide-focus).is-focused,
.ids-toggle-button.btn-primary:not(.hide-focus).focus-within,
.ids-toggle-button.btn-primary:not(.hide-focus):focus,
.ids-menu-button.btn-primary:not(.hide-focus).is-active,
.ids-menu-button.btn-primary:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary:not(.hide-focus):focus {
  border-color: var(--ids-button-primary-color-border-focus);
}
.ids-button.btn-primary:hover,
.ids-toggle-button.btn-primary:hover,
.ids-menu-button.btn-primary:hover {
  background-color: var(--ids-button-primary-color-background-hover);
  border-color: var(--ids-button-primary-color-border-hover);
}
.ids-button.btn-primary[disabled],
.ids-toggle-button.btn-primary[disabled],
.ids-menu-button.btn-primary[disabled] {
  background-color: var(--ids-button-primary-color-background-disabled);
  border-color: var(--ids-button-primary-color-border-disabled);
  color: var(--ids-button-primary-color-text-disabled);
  opacity: var(--ids-button-primary-opacity-disabled);
}
.ids-button.btn-primary:active:not([disabled]),
.ids-toggle-button.btn-primary:active:not([disabled]),
.ids-menu-button.btn-primary:active:not([disabled]) {
  background-color: var(--ids-button-primary-color-background-pressed);
  border-color: var(--ids-button-primary-color-border-pressed);
  color: var(--ids-button-primary-color-text-pressed);
}
.ids-button.btn-primary-destructive,
.ids-toggle-button.btn-primary-destructive,
.ids-menu-button.btn-primary-destructive {
  background-color: var(--ids-button-destructive-color-background-default);
  border-color: var(--ids-button-destructive-color-border-default);
  color: var(--ids-button-destructive-color-text-default);
}
.ids-button.btn-primary-destructive:not(.hide-focus).is-active, .ids-button.btn-primary-destructive:not(.hide-focus).is-focused, .ids-button.btn-primary-destructive:not(.hide-focus).focus-within, .ids-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-toggle-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-color-border-focus);
}
.ids-button.btn-primary-destructive:hover,
.ids-toggle-button.btn-primary-destructive:hover,
.ids-menu-button.btn-primary-destructive:hover {
  background-color: var(--ids-button-destructive-color-background-hover);
  border-color: var(--ids-button-destructive-color-border-hover);
  color: var(--ids-button-destructive-color-text-hover);
}
.ids-button.btn-primary-destructive[disabled],
.ids-toggle-button.btn-primary-destructive[disabled],
.ids-menu-button.btn-primary-destructive[disabled] {
  background-color: var(--ids-button-destructive-color-background-disabled);
  border-color: var(--ids-button-destructive-color-border-disabled);
  color: var(--ids-button-destructive-color-text-disabled);
  opacity: var(--ids-button-destructive-opacity-disabled);
}
@keyframes dot-flashing {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-primary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-primary-step-2);
  }
}
@keyframes dot-flashing-colors-secondary {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-secondary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-secondary-step-2);
  }
}
@keyframes dot-flashing-colors-tertiary {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-2);
  }
}
.ids-button .loading-dots-start,
.ids-toggle-button .loading-dots-start,
.ids-menu-button .loading-dots-start {
  padding-inline-start: 3px !important;
  padding-inline-end: 7px !important;
  gap: 2px;
}
.ids-button .loading-dots,
.ids-toggle-button .loading-dots,
.ids-menu-button .loading-dots {
  display: none;
  position: relative;
  flex-direction: row;
  gap: 2px;
  padding-inline-start: 7px;
  padding-inline-end: 3px;
}
.ids-button .loading-dots .dot,
.ids-toggle-button .loading-dots .dot,
.ids-menu-button .loading-dots .dot {
  display: inline-flex;
  position: relative;
  width: 3px;
  height: 3px;
  border-radius: 5px;
  background-color: var(--ids-button-ai-color-loading-dot-default);
  color: var(--ids-button-ai-color-loading-dot-default);
}
.ids-button.btn-primary-generative-ai,
.ids-toggle-button.btn-primary-generative-ai,
.ids-menu-button.btn-primary-generative-ai {
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-primary-sparkle-icon-color-fill);
  background: border-box var(--ids-button-ai-color-background-default);
  border: none;
  color: var(--ids-button-ai-color-text-default);
  align-items: center;
  min-width: 34px;
  min-height: 34px;
}
.ids-button.btn-primary-generative-ai.compact,
.ids-toggle-button.btn-primary-generative-ai.compact,
.ids-menu-button.btn-primary-generative-ai.compact {
  min-width: var(--ids-button-compact-width);
  min-height: var(--ids-button-compact-width);
}
.ids-button.btn-primary-generative-ai:hover,
.ids-toggle-button.btn-primary-generative-ai:hover,
.ids-menu-button.btn-primary-generative-ai:hover {
  background: border-box var(--ids-button-ai-color-background-hover);
}
.ids-button.btn-primary-generative-ai:active, .ids-button.btn-primary-generative-ai.gen-ai-active,
.ids-toggle-button.btn-primary-generative-ai:active,
.ids-toggle-button.btn-primary-generative-ai.gen-ai-active,
.ids-menu-button.btn-primary-generative-ai:active,
.ids-menu-button.btn-primary-generative-ai.gen-ai-active {
  background: border-box var(--ids-button-ai-color-background-active);
  color: var(--ids-button-ai-color-text-active);
}
.ids-button.btn-primary-generative-ai[disabled],
.ids-toggle-button.btn-primary-generative-ai[disabled],
.ids-menu-button.btn-primary-generative-ai[disabled] {
  background: border-box var(--ids-button-ai-color-background-disabled);
}
.ids-button.btn-primary-generative-ai.color-variant-alternate-formatter, .ids-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover,
.ids-toggle-button.btn-primary-generative-ai.color-variant-alternate-formatter,
.ids-toggle-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover,
.ids-menu-button.btn-primary-generative-ai.color-variant-alternate-formatter,
.ids-menu-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover {
  color: var(--ids-color-white-100);
  min-height: var(--ids-button-formatter-size);
  min-width: 34px;
}
.ids-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1),
.ids-toggle-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1),
.ids-menu-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s;
}
.ids-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2),
.ids-toggle-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2),
.ids-menu-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3),
.ids-toggle-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3),
.ids-menu-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s;
}
.ids-button.btn-secondary-generative-ai,
.ids-toggle-button.btn-secondary-generative-ai,
.ids-menu-button.btn-secondary-generative-ai {
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-secondary-sparkle-icon-color-fill);
  background: var(--ids-button-ai-secondary-color-background-default);
  border: 1px solid var(--ids-button-ai-secondary-color-border-default);
  color: var(--ids-button-ai-secondary-color-default);
  align-items: center;
}
.ids-button.btn-secondary-generative-ai:hover:not([disabled]),
.ids-toggle-button.btn-secondary-generative-ai:hover:not([disabled]),
.ids-menu-button.btn-secondary-generative-ai:hover:not([disabled]) {
  background: var(--ids-button-ai-secondary-color-background-hover);
  color: var(--ids-button-ai-secondary-color-hover);
  border-color: var(--ids-button-ai-secondary-color-border-hover);
}
.ids-button.btn-secondary-generative-ai:active:not([disabled]),
.ids-toggle-button.btn-secondary-generative-ai:active:not([disabled]),
.ids-menu-button.btn-secondary-generative-ai:active:not([disabled]) {
  background: var(--ids-button-ai-secondary-color-background-active);
  color: var(--ids-button-ai-secondary-color-active);
  border-color: var(--ids-button-ai-secondary-color-border-active);
}
.ids-button.btn-secondary-generative-ai ::slotted(ids-icon[icon=genai]),
.ids-toggle-button.btn-secondary-generative-ai ::slotted(ids-icon[icon=genai]),
.ids-menu-button.btn-secondary-generative-ai ::slotted(ids-icon[icon=genai]) {
  --ids-button-ai-color-icon-primary: var(--ids-button-ai-color-icon-primary-hover);
  --ids-button-ai-color-icon-secondary: var(--ids-button-ai-color-icon-secondary-hover);
}
.ids-button.btn-secondary-generative-ai.gen-ai-active,
.ids-toggle-button.btn-secondary-generative-ai.gen-ai-active,
.ids-menu-button.btn-secondary-generative-ai.gen-ai-active {
  background: var(--ids-button-ai-secondary-color-background-active);
}
.ids-button.btn-secondary-generative-ai[disabled],
.ids-toggle-button.btn-secondary-generative-ai[disabled],
.ids-menu-button.btn-secondary-generative-ai[disabled] {
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-button.btn-secondary-generative-ai .loading-dots .dot,
.ids-toggle-button.btn-secondary-generative-ai .loading-dots .dot,
.ids-menu-button.btn-secondary-generative-ai .loading-dots .dot {
  background-color: var(--ids-button-ai-color-loading-dot-secondary);
  color: var(--ids-button-ai-color-loading-dot-secondary);
}
.ids-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(1),
.ids-toggle-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(1),
.ids-menu-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing-colors-secondary 1s infinite alternate;
  animation-delay: 0s;
}
.ids-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(2),
.ids-toggle-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(2),
.ids-menu-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing-colors-secondary 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(3),
.ids-toggle-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(3),
.ids-menu-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing-colors-secondary 1s infinite alternate;
  animation-delay: 1s;
}
.ids-button.btn-tertiary-generative-ai,
.ids-toggle-button.btn-tertiary-generative-ai,
.ids-menu-button.btn-tertiary-generative-ai {
  --ids-button-tertiary-ai-shadow-focus: var(--ids-button-tertiary-shadow-focus);
  --ids-button-ai-color-icon-secondary-hover: var(--ids-color-action-stronger);
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-tertiary-sparkle-icon-color-fill);
  background: var(--ids-button-ai-tertiary-color-background-default);
  background-clip: text;
  align-items: center;
  color: var(--ids-button-ai-tertiary-color-text-default);
}
.ids-button.btn-tertiary-generative-ai:hover,
.ids-toggle-button.btn-tertiary-generative-ai:hover,
.ids-menu-button.btn-tertiary-generative-ai:hover {
  background: var(--ids-button-ai-tertiary-color-background-hover);
}
.ids-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=genai]),
.ids-toggle-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=genai]),
.ids-menu-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=genai]) {
  --ids-button-ai-color-icon-primary: var(--ids-button-ai-tertiary-color-text-default);
  --ids-button-ai-color-icon-secondary: var(--ids-button-ai-tertiary-color-text-default);
}
.ids-button.btn-tertiary-generative-ai:active, .ids-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-toggle-button.btn-tertiary-generative-ai:active,
.ids-toggle-button.btn-tertiary-generative-ai.gen-ai-active,
.ids-menu-button.btn-tertiary-generative-ai:active,
.ids-menu-button.btn-tertiary-generative-ai.gen-ai-active {
  background: var(--ids-button-ai-tertiary-color-background-active);
}
.ids-button.btn-tertiary-generative-ai[disabled],
.ids-toggle-button.btn-tertiary-generative-ai[disabled],
.ids-menu-button.btn-tertiary-generative-ai[disabled] {
  background: var(--ids-button-tertiary-ai-color-background-disabled);
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1),
.ids-toggle-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1),
.ids-menu-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing-colors-tertiary 1s infinite alternate;
  animation-delay: 0s;
}
.ids-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2),
.ids-toggle-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2),
.ids-menu-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing-colors-tertiary 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3),
.ids-toggle-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3),
.ids-menu-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing-colors-tertiary 1s infinite alternate;
  animation-delay: 1s;
}
.ids-button.btn-secondary,
.ids-toggle-button.btn-secondary,
.ids-menu-button.btn-secondary {
  background-color: var(--ids-button-secondary-color-background-default);
  border-width: var(--ids-button-secondary-border-width);
  border-color: var(--ids-button-secondary-color-border-default);
  color: var(--ids-button-secondary-color-text-default);
}
.ids-button.btn-secondary:not(.hide-focus).is-active, .ids-button.btn-secondary:not(.hide-focus).is-focused, .ids-button.btn-secondary:not(.hide-focus).focus-within, .ids-button.btn-secondary:not(.hide-focus):focus,
.ids-toggle-button.btn-secondary:not(.hide-focus).is-active,
.ids-toggle-button.btn-secondary:not(.hide-focus).is-focused,
.ids-toggle-button.btn-secondary:not(.hide-focus).focus-within,
.ids-toggle-button.btn-secondary:not(.hide-focus):focus,
.ids-menu-button.btn-secondary:not(.hide-focus).is-active,
.ids-menu-button.btn-secondary:not(.hide-focus).is-focused,
.ids-menu-button.btn-secondary:not(.hide-focus).focus-within,
.ids-menu-button.btn-secondary:not(.hide-focus):focus {
  background-color: var(--ids-button-secondary-color-background-focus);
  border-color: var(--ids-button-secondary-color-border-focus);
}
.ids-button.btn-secondary:hover:not([disabled]),
.ids-toggle-button.btn-secondary:hover:not([disabled]),
.ids-menu-button.btn-secondary:hover:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-hover);
  border-color: var(--ids-button-secondary-color-border-hover);
  color: var(--ids-button-secondary-color-text-hover);
}
.ids-button.btn-secondary[disabled],
.ids-toggle-button.btn-secondary[disabled],
.ids-menu-button.btn-secondary[disabled] {
  background-color: var(--ids-button-secondary-color-background-disabled);
  border-color: var(--ids-button-secondary-color-border-disabled);
  color: var(--ids-button-secondary-color-text-disabled);
  opacity: var(--ids-button-secondary-opacity-disabled);
}
.ids-button.btn-secondary:active:not([disabled]),
.ids-toggle-button.btn-secondary:active:not([disabled]),
.ids-menu-button.btn-secondary:active:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-pressed);
  border-color: var(--ids-button-secondary-color-border-pressed);
  color: var(--ids-button-secondary-color-text-pressed);
}
.ids-button.color-variant-alternate:hover,
.ids-toggle-button.color-variant-alternate:hover,
.ids-menu-button.color-variant-alternate:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.ids-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover,
.ids-toggle-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover,
.ids-menu-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover {
  background-color: var(--ids-search-field-header-color-icon-hover);
}
.ids-button.color-variant-app-menu:hover,
.ids-toggle-button.color-variant-app-menu:hover,
.ids-menu-button.color-variant-app-menu:hover {
  background-color: rgba(255, 255, 255, 0.15);
}
.ids-button.color-variant-alternate, .ids-button.color-variant-alternate-formatter,
.ids-toggle-button.color-variant-alternate,
.ids-toggle-button.color-variant-alternate-formatter,
.ids-menu-button.color-variant-alternate,
.ids-menu-button.color-variant-alternate-formatter {
  color: var(--ids-button-alternate-color-text-default);
  opacity: 0.8;
}
.ids-button.color-variant-alternate:not(.hide-focus).is-active, .ids-button.color-variant-alternate:not(.hide-focus).is-focused, .ids-button.color-variant-alternate:not(.hide-focus).focus-within, .ids-button.color-variant-alternate:not(.hide-focus):focus, .ids-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-toggle-button.color-variant-alternate:not(.hide-focus).is-active,
.ids-toggle-button.color-variant-alternate:not(.hide-focus).is-focused,
.ids-toggle-button.color-variant-alternate:not(.hide-focus).focus-within,
.ids-toggle-button.color-variant-alternate:not(.hide-focus):focus,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-menu-button.color-variant-alternate:not(.hide-focus).is-active,
.ids-menu-button.color-variant-alternate:not(.hide-focus).is-focused,
.ids-menu-button.color-variant-alternate:not(.hide-focus).focus-within,
.ids-menu-button.color-variant-alternate:not(.hide-focus):focus,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-button-formatter-color-border-focus);
  opacity: 1;
}
.ids-button.color-variant-alternate:hover, .ids-button.color-variant-alternate-formatter:hover,
.ids-toggle-button.color-variant-alternate:hover,
.ids-toggle-button.color-variant-alternate-formatter:hover,
.ids-menu-button.color-variant-alternate:hover,
.ids-menu-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  border-color: var(--ids-color-transparent);
  color: var(--ids-button-formatter-color-text-hover);
  opacity: 1;
}
.ids-button.color-variant-alternate[disabled], .ids-button.color-variant-alternate-formatter[disabled],
.ids-toggle-button.color-variant-alternate[disabled],
.ids-toggle-button.color-variant-alternate-formatter[disabled],
.ids-menu-button.color-variant-alternate[disabled],
.ids-menu-button.color-variant-alternate-formatter[disabled] {
  background-color: var(--ids-color-transparent);
  opacity: var(--ids-button-formatter-opacity-disabled);
}
.ids-button.color-variant-alternate-formatter,
.ids-toggle-button.color-variant-alternate-formatter,
.ids-menu-button.color-variant-alternate-formatter {
  background-color: var(--ids-button-formatter-color-background-default);
  border-color: var(--ids-button-formatter-color-border-default);
  color: var(--ids-button-formatter-color-text-default);
  height: var(--ids-button-formatter-size);
  min-width: var(--ids-button-formatter-size);
}
.ids-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-toggle-button.color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-menu-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-color-border-focus);
}
.ids-button.color-variant-alternate-formatter[disabled],
.ids-toggle-button.color-variant-alternate-formatter[disabled],
.ids-menu-button.color-variant-alternate-formatter[disabled] {
  color: var(--ids-button-formatter-color-text-disabled);
}
.ids-button.color-variant-alternate-formatter:hover,
.ids-toggle-button.color-variant-alternate-formatter:hover,
.ids-menu-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  color: var(--ids-button-formatter-color-text-hover);
}
.ids-button.color-variant-alternate-formatter.is-active,
.ids-toggle-button.color-variant-alternate-formatter.is-active,
.ids-menu-button.color-variant-alternate-formatter.is-active {
  color: var(--ids-button-formatter-color-active);
}
.ids-button.color-variant-alternate-formatter.ids-menu-button.compact,
.ids-toggle-button.color-variant-alternate-formatter.ids-menu-button.compact,
.ids-menu-button.color-variant-alternate-formatter.ids-menu-button.compact {
  padding: var(--ids-space-2xs);
  padding-inline: var(--ids-space-2xs);
}
.ids-button.color-variant-alternate-formatter.ids-menu-button.compact.square,
.ids-toggle-button.color-variant-alternate-formatter.ids-menu-button.compact.square,
.ids-menu-button.color-variant-alternate-formatter.ids-menu-button.compact.square {
  border-radius: var(--ids-border-radius-xs);
  width: 34px;
}
.ids-button.color-variant-alternate-formatter[editor-action=sourcemode], .ids-button.color-variant-alternate-formatter[editor-action=editormode],
.ids-toggle-button.color-variant-alternate-formatter[editor-action=sourcemode],
.ids-toggle-button.color-variant-alternate-formatter[editor-action=editormode],
.ids-menu-button.color-variant-alternate-formatter[editor-action=sourcemode],
.ids-menu-button.color-variant-alternate-formatter[editor-action=editormode] {
  --ids-button-icon-width: 54px;
}
.ids-button.color-variant-module,
.ids-toggle-button.color-variant-module,
.ids-menu-button.color-variant-module {
  border: 0;
  color: var(--ids-button-module-color-text-default);
}
.ids-button.color-variant-module:not(.square),
.ids-toggle-button.color-variant-module:not(.square),
.ids-menu-button.color-variant-module:not(.square) {
  border-radius: var(--ids-button-module-border-radius);
}
.ids-button.color-variant-module:hover,
.ids-toggle-button.color-variant-module:hover,
.ids-menu-button.color-variant-module:hover {
  background-color: var(--ids-button-module-color-background-hover);
  color: var(--ids-button-module-color-text-hover);
}
.ids-button:not(.no-padding),
.ids-toggle-button:not(.no-padding),
.ids-menu-button:not(.no-padding) {
  padding-inline: var(--ids-button-padding-inline);
}
.ids-button.btn-tertiary, .ids-button.btn-tertiary-destructive,
.ids-toggle-button.btn-tertiary,
.ids-toggle-button.btn-tertiary-destructive,
.ids-menu-button.btn-tertiary,
.ids-menu-button.btn-tertiary-destructive {
  padding-inline: var(--ids-space-12);
}
.ids-button.no-padding,
.ids-toggle-button.no-padding,
.ids-menu-button.no-padding {
  padding-inline: var(--ids-space-12);
}

.ids-menu-button.sub-tab-button.is-active {
  background-color: unset;
}

.ids-menu-button.is-active,
.ids-menu-button.is-active:hover {
  background-color: var(--ids-button-menu-background-color-active);
  color: var(--ids-button-menu-color-text-active);
}

.ids-menu-button.formatter-width:not(.no-padding):not(.ids-icon-button) {
  padding-inline-start: calc(var(--ids-space-xs) - 1px);
  padding-inline-end: calc(var(--ids-space-xs) - 1px);
}
.ids-menu-button.formatter-width:not(.formatter-width-percentage) {
  justify-content: normal;
}
.ids-menu-button.formatter-width:not(.formatter-width-percentage) .ids-icon {
  position: absolute;
  inset-inline-end: var(--ids-space-2xs);
}

::slotted(ids-icon[icon=logo]) {
  height: 30px;
  opacity: 0.8;
}

.ids-icon-button {
  box-shadow: var(--ids-shadow-none);
  font-weight: var(--ids-font-weight-normal);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
  overflow: hidden;
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
  position: relative;
  /* stylelint-disable-next-line no-duplicate-selectors */
}
.ids-icon-button, .ids-icon-button::before, .ids-icon-button::after {
  box-sizing: border-box;
}
.ids-icon-button * {
  pointer-events: none;
}
.ids-icon-button {
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-color-text-default);
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), border-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease), opacity var(--ids-motion-duration) var(--ids-motion-ease);
  white-space: nowrap;
}
.ids-icon-button:focus {
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-icon-button:not([disabled]) {
  cursor: var(--ids-cursor-pointer);
}
.ids-icon-button span {
  vertical-align: bottom;
}
.ids-icon-button span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-icon-button:not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon=genai])) {
  margin-inline-end: calc(var(--ids-space-2xs) + 3px);
}
.ids-icon-button .ids-icon {
  vertical-align: middle;
}
.ids-icon-button.align-icon-end ::slotted(ids-icon) {
  margin-inline-start: var(--ids-space-2xs);
}
.ids-icon-button.content-align-start {
  justify-content: start;
}
.ids-icon-button.content-align-end {
  justify-content: end;
}
.ids-icon-button.no-margins {
  margin-inline: var(--ids-space-none);
}
.ids-icon-button.field-height-xxs:not(.btn-secondary):not(.no-margins) {
  margin-block-start: 3px;
  margin-inline-end: -2px;
  height: 22px;
  width: 22px;
}
.ids-icon-button ::slotted(span) {
  font-weight: inherit !important;
}
.ids-icon-button {
  display: inline-flex;
  font-weight: var(--ids-button-tertiary-font-weight);
  border-radius: var(--ids-button-radius);
  background-color: var(--ids-button-tertiary-color-background-default);
  border-color: var(--ids-button-tertiary-color-border-default);
  color: var(--ids-button-tertiary-color-text-default);
}
.ids-icon-button:not(.hide-focus).is-active:not([readonly]), .ids-icon-button:not(.hide-focus).is-focused:not([readonly]), .ids-icon-button:not(.hide-focus):focus:not([readonly]), .ids-icon-button:not(.hide-focus):focus-within:not([readonly]) {
  border-color: var(--ids-button-tertiary-color-border-focus);
}
.ids-icon-button:hover {
  color: var(--ids-button-tertiary-color-text-hover);
  background-color: var(--ids-button-tertiary-color-background-hover);
  border-color: var(--ids-button-tertiary-color-border-hover);
}
.ids-icon-button[disabled] {
  color: var(--ids-button-tertiary-color-text-disabled);
  background-color: var(--ids-button-tertiary-color-background-disabled);
  border-color: var(--ids-button-tertiary-color-border-disabled);
  opacity: var(--ids-button-tertiary-opacity-disabled);
}
.ids-icon-button:active:not([disabled]) {
  background-color: var(--ids-button-tertiary-color-background-pressed);
  border-color: var(--ids-button-tertiary-color-border-pressed);
  color: var(--ids-button-tertiary-color-text-pressed);
}
.ids-icon-button.btn-tertiary-destructive {
  background-color: var(--ids-button-destructive-tertiary-color-background-default);
  border-color: var(--ids-button-destructive-tertiary-color-border-default);
  color: var(--ids-button-destructive-tertiary-color-text-default);
}
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-active, .ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-focused, .ids-icon-button.btn-tertiary-destructive:not(.hide-focus).focus-within, .ids-icon-button.btn-tertiary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-tertiary-color-border-focus);
}
.ids-icon-button.btn-tertiary-destructive:hover {
  background-color: var(--ids-button-destructive-tertiary-color-background-hover);
  border-color: var(--ids-button-destructive-tertiary-color-border-hover);
  color: var(--ids-button-destructive-tertiary-color-text-hover);
}
.ids-icon-button.btn-tertiary-destructive[disabled] {
  color: var(--ids-button-destructive-tertiary-color-text-disabled);
  background-color: var(--ids-button-destructive-tertiary-color-background-disabled);
  border-color: var(--ids-button-destructive-tertiary-color-border-disabled);
}
.ids-icon-button.btn-primary {
  background-color: var(--ids-button-primary-color-background-default);
  border-color: var(--ids-button-primary-color-border-default);
  border: 1px solid var(--ids-button-primary-color-border-default);
  color: var(--ids-button-primary-color-text-default);
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
}
.ids-icon-button.btn-primary:not(.hide-focus).is-active, .ids-icon-button.btn-primary:not(.hide-focus).is-focused, .ids-icon-button.btn-primary:not(.hide-focus).focus-within, .ids-icon-button.btn-primary:not(.hide-focus):focus {
  border-color: var(--ids-button-primary-color-border-focus);
}
.ids-icon-button.btn-primary:hover {
  background-color: var(--ids-button-primary-color-background-hover);
  border-color: var(--ids-button-primary-color-border-hover);
}
.ids-icon-button.btn-primary[disabled] {
  background-color: var(--ids-button-primary-color-background-disabled);
  border-color: var(--ids-button-primary-color-border-disabled);
  color: var(--ids-button-primary-color-text-disabled);
  opacity: var(--ids-button-primary-opacity-disabled);
}
.ids-icon-button.btn-primary:active:not([disabled]) {
  background-color: var(--ids-button-primary-color-background-pressed);
  border-color: var(--ids-button-primary-color-border-pressed);
  color: var(--ids-button-primary-color-text-pressed);
}
.ids-icon-button.btn-primary-destructive {
  background-color: var(--ids-button-destructive-color-background-default);
  border-color: var(--ids-button-destructive-color-border-default);
  color: var(--ids-button-destructive-color-text-default);
}
.ids-icon-button.btn-primary-destructive:not(.hide-focus).is-active, .ids-icon-button.btn-primary-destructive:not(.hide-focus).is-focused, .ids-icon-button.btn-primary-destructive:not(.hide-focus).focus-within, .ids-icon-button.btn-primary-destructive:not(.hide-focus):focus {
  border-color: var(--ids-button-destructive-color-border-focus);
}
.ids-icon-button.btn-primary-destructive:hover {
  background-color: var(--ids-button-destructive-color-background-hover);
  border-color: var(--ids-button-destructive-color-border-hover);
  color: var(--ids-button-destructive-color-text-hover);
}
.ids-icon-button.btn-primary-destructive[disabled] {
  background-color: var(--ids-button-destructive-color-background-disabled);
  border-color: var(--ids-button-destructive-color-border-disabled);
  color: var(--ids-button-destructive-color-text-disabled);
  opacity: var(--ids-button-destructive-opacity-disabled);
}
@keyframes dot-flashing {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-primary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-primary-step-2);
  }
}
@keyframes dot-flashing-colors-secondary {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-secondary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-secondary-step-2);
  }
}
@keyframes dot-flashing-colors-tertiary {
  0% {
    background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-1);
  }
  50%, 100% {
    background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-2);
  }
}
.ids-icon-button .loading-dots-start {
  padding-inline-start: 3px !important;
  padding-inline-end: 7px !important;
  gap: 2px;
}
.ids-icon-button .loading-dots {
  display: none;
  position: relative;
  flex-direction: row;
  gap: 2px;
  padding-inline-start: 7px;
  padding-inline-end: 3px;
}
.ids-icon-button .loading-dots .dot {
  display: inline-flex;
  position: relative;
  width: 3px;
  height: 3px;
  border-radius: 5px;
  background-color: var(--ids-button-ai-color-loading-dot-default);
  color: var(--ids-button-ai-color-loading-dot-default);
}
.ids-icon-button.btn-primary-generative-ai {
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-primary-sparkle-icon-color-fill);
  background: border-box var(--ids-button-ai-color-background-default);
  border: none;
  color: var(--ids-button-ai-color-text-default);
  align-items: center;
  min-width: 34px;
  min-height: 34px;
}
.ids-icon-button.btn-primary-generative-ai.compact {
  min-width: var(--ids-button-compact-width);
  min-height: var(--ids-button-compact-width);
}
.ids-icon-button.btn-primary-generative-ai:hover {
  background: border-box var(--ids-button-ai-color-background-hover);
}
.ids-icon-button.btn-primary-generative-ai:active, .ids-icon-button.btn-primary-generative-ai.gen-ai-active {
  background: border-box var(--ids-button-ai-color-background-active);
  color: var(--ids-button-ai-color-text-active);
}
.ids-icon-button.btn-primary-generative-ai[disabled] {
  background: border-box var(--ids-button-ai-color-background-disabled);
}
.ids-icon-button.btn-primary-generative-ai.color-variant-alternate-formatter, .ids-icon-button.btn-primary-generative-ai.color-variant-alternate-formatter:hover {
  color: var(--ids-color-white-100);
  min-height: var(--ids-button-formatter-size);
  min-width: 34px;
}
.ids-icon-button.btn-primary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s;
}
.ids-icon-button.btn-primary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-icon-button.btn-primary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s;
}
.ids-icon-button.btn-secondary-generative-ai {
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-secondary-sparkle-icon-color-fill);
  background: var(--ids-button-ai-secondary-color-background-default);
  border: 1px solid var(--ids-button-ai-secondary-color-border-default);
  color: var(--ids-button-ai-secondary-color-default);
  align-items: center;
}
.ids-icon-button.btn-secondary-generative-ai:hover:not([disabled]) {
  background: var(--ids-button-ai-secondary-color-background-hover);
  color: var(--ids-button-ai-secondary-color-hover);
  border-color: var(--ids-button-ai-secondary-color-border-hover);
}
.ids-icon-button.btn-secondary-generative-ai:active:not([disabled]) {
  background: var(--ids-button-ai-secondary-color-background-active);
  color: var(--ids-button-ai-secondary-color-active);
  border-color: var(--ids-button-ai-secondary-color-border-active);
}
.ids-icon-button.btn-secondary-generative-ai ::slotted(ids-icon[icon=genai]) {
  --ids-button-ai-color-icon-primary: var(--ids-button-ai-color-icon-primary-hover);
  --ids-button-ai-color-icon-secondary: var(--ids-button-ai-color-icon-secondary-hover);
}
.ids-icon-button.btn-secondary-generative-ai.gen-ai-active {
  background: var(--ids-button-ai-secondary-color-background-active);
}
.ids-icon-button.btn-secondary-generative-ai[disabled] {
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-icon-button.btn-secondary-generative-ai .loading-dots .dot {
  background-color: var(--ids-button-ai-color-loading-dot-secondary);
  color: var(--ids-button-ai-color-loading-dot-secondary);
}
.ids-icon-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing-colors-secondary 1s infinite alternate;
  animation-delay: 0s;
}
.ids-icon-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing-colors-secondary 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-icon-button.btn-secondary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing-colors-secondary 1s infinite alternate;
  animation-delay: 1s;
}
.ids-icon-button.btn-tertiary-generative-ai {
  --ids-button-tertiary-ai-shadow-focus: var(--ids-button-tertiary-shadow-focus);
  --ids-button-ai-color-icon-secondary-hover: var(--ids-color-action-stronger);
  --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-tertiary-sparkle-icon-color-fill);
  background: var(--ids-button-ai-tertiary-color-background-default);
  background-clip: text;
  align-items: center;
  color: var(--ids-button-ai-tertiary-color-text-default);
}
.ids-icon-button.btn-tertiary-generative-ai:hover {
  background: var(--ids-button-ai-tertiary-color-background-hover);
}
.ids-icon-button.btn-tertiary-generative-ai ::slotted(ids-icon[icon=genai]) {
  --ids-button-ai-color-icon-primary: var(--ids-button-ai-tertiary-color-text-default);
  --ids-button-ai-color-icon-secondary: var(--ids-button-ai-tertiary-color-text-default);
}
.ids-icon-button.btn-tertiary-generative-ai:active, .ids-icon-button.btn-tertiary-generative-ai.gen-ai-active {
  background: var(--ids-button-ai-tertiary-color-background-active);
}
.ids-icon-button.btn-tertiary-generative-ai[disabled] {
  background: var(--ids-button-tertiary-ai-color-background-disabled);
  opacity: var(--ids-button-ai-opacity-disabled);
}
.ids-icon-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(1) {
  animation: dot-flashing-colors-tertiary 1s infinite alternate;
  animation-delay: 0s;
}
.ids-icon-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(2) {
  animation: dot-flashing-colors-tertiary 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.ids-icon-button.btn-tertiary-generative-ai .loading-dots .dot:nth-child(3) {
  animation: dot-flashing-colors-tertiary 1s infinite alternate;
  animation-delay: 1s;
}
.ids-icon-button.btn-secondary {
  background-color: var(--ids-button-secondary-color-background-default);
  border-width: var(--ids-button-secondary-border-width);
  border-color: var(--ids-button-secondary-color-border-default);
  color: var(--ids-button-secondary-color-text-default);
}
.ids-icon-button.btn-secondary:not(.hide-focus).is-active, .ids-icon-button.btn-secondary:not(.hide-focus).is-focused, .ids-icon-button.btn-secondary:not(.hide-focus).focus-within, .ids-icon-button.btn-secondary:not(.hide-focus):focus {
  background-color: var(--ids-button-secondary-color-background-focus);
  border-color: var(--ids-button-secondary-color-border-focus);
}
.ids-icon-button.btn-secondary:hover:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-hover);
  border-color: var(--ids-button-secondary-color-border-hover);
  color: var(--ids-button-secondary-color-text-hover);
}
.ids-icon-button.btn-secondary[disabled] {
  background-color: var(--ids-button-secondary-color-background-disabled);
  border-color: var(--ids-button-secondary-color-border-disabled);
  color: var(--ids-button-secondary-color-text-disabled);
  opacity: var(--ids-button-secondary-opacity-disabled);
}
.ids-icon-button.btn-secondary:active:not([disabled]) {
  background-color: var(--ids-button-secondary-color-background-pressed);
  border-color: var(--ids-button-secondary-color-border-pressed);
  color: var(--ids-button-secondary-color-text-pressed);
}
.ids-icon-button.color-variant-alternate:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.ids-icon-button.color-variant-alternate.ids-trigger-button:not([readonly]):hover {
  background-color: var(--ids-search-field-header-color-icon-hover);
}
.ids-icon-button.color-variant-app-menu:hover {
  background-color: rgba(255, 255, 255, 0.15);
}
.ids-icon-button.color-variant-alternate, .ids-icon-button.color-variant-alternate-formatter {
  color: var(--ids-button-alternate-color-text-default);
  opacity: 0.8;
}
.ids-icon-button.color-variant-alternate:not(.hide-focus).is-active, .ids-icon-button.color-variant-alternate:not(.hide-focus).is-focused, .ids-icon-button.color-variant-alternate:not(.hide-focus).focus-within, .ids-icon-button.color-variant-alternate:not(.hide-focus):focus, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-button-formatter-color-border-focus);
  opacity: 1;
}
.ids-icon-button.color-variant-alternate:hover, .ids-icon-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  border-color: var(--ids-color-transparent);
  color: var(--ids-button-formatter-color-text-hover);
  opacity: 1;
}
.ids-icon-button.color-variant-alternate[disabled], .ids-icon-button.color-variant-alternate-formatter[disabled] {
  background-color: var(--ids-color-transparent);
  opacity: var(--ids-button-formatter-opacity-disabled);
}
.ids-icon-button.color-variant-alternate-formatter {
  background-color: var(--ids-button-formatter-color-background-default);
  border-color: var(--ids-button-formatter-color-border-default);
  color: var(--ids-button-formatter-color-text-default);
  height: var(--ids-button-formatter-size);
  min-width: var(--ids-button-formatter-size);
}
.ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-icon-button.color-variant-alternate-formatter:not(.hide-focus):focus {
  border-color: var(--ids-color-border-focus);
}
.ids-icon-button.color-variant-alternate-formatter[disabled] {
  color: var(--ids-button-formatter-color-text-disabled);
}
.ids-icon-button.color-variant-alternate-formatter:hover {
  background-color: var(--ids-button-formatter-color-background-hover);
  color: var(--ids-button-formatter-color-text-hover);
}
.ids-icon-button.color-variant-alternate-formatter.is-active {
  color: var(--ids-button-formatter-color-active);
}
.ids-icon-button.color-variant-alternate-formatter.ids-menu-button.compact {
  padding: var(--ids-space-2xs);
  padding-inline: var(--ids-space-2xs);
}
.ids-icon-button.color-variant-alternate-formatter.ids-menu-button.compact.square {
  border-radius: var(--ids-border-radius-xs);
  width: 34px;
}
.ids-icon-button.color-variant-alternate-formatter[editor-action=sourcemode], .ids-icon-button.color-variant-alternate-formatter[editor-action=editormode] {
  --ids-button-icon-width: 54px;
}
.ids-icon-button.color-variant-module {
  border: 0;
  color: var(--ids-button-module-color-text-default);
}
.ids-icon-button.color-variant-module:not(.square) {
  border-radius: var(--ids-button-module-border-radius);
}
.ids-icon-button.color-variant-module:hover {
  background-color: var(--ids-button-module-color-background-hover);
  color: var(--ids-button-module-color-text-hover);
}
.ids-icon-button {
  padding-inline-start: var(--ids-button-icon-padding);
  padding-inline-end: var(--ids-button-icon-padding);
  padding-block-start: var(--ids-button-icon-padding);
  padding-block-end: var(--ids-button-icon-padding);
}
.ids-icon-button:not(.no-padding):not(.sub-tab-button) {
  padding-inline-start: var(--ids-button-icon-padding);
  padding-inline-end: var(--ids-button-icon-padding);
  padding-top: var(--ids-button-icon-padding);
  padding-bottom: var(--ids-button-icon-padding);
}
.ids-icon-button:not(.no-padding):not(.sub-tab-button):not(.ids-trigger-button), .ids-icon-button:not(.no-padding):not(.sub-tab-button):not(.compact) .ids-icon-button:not(.no-padding):not(.sub-tab-button):not(.ids-sub-tab-close-button) {
  height: var(--ids-button-icon-height);
  width: var(--ids-button-icon-width);
}
.ids-icon-button.sub-tab-button {
  padding: 0;
}
.ids-icon-button:not(.no-padding):not(.ids-trigger-button).compact {
  height: calc(var(--ids-button-icon-compact-height) + 10px);
  width: calc(var(--ids-button-icon-compact-width) + 8px);
}
.ids-icon-button.compact {
  padding-inline-start: calc(var(--ids-space-xs) + 1px);
}
.ids-icon-button.compact.gen-ai-active .loading-dots {
  padding-inline-start: 1px;
}
.ids-icon-button:not(.square) {
  border-radius: var(--ids-button-radius);
}
.ids-icon-button.square {
  border-radius: var(--ids-border-radius-none);
}
.ids-icon-button.square:hover ::slotted(ids-icon[icon=logo]) {
  opacity: 1;
}
.ids-icon-button .ids-icon:not(.dropdown-icon) {
  display: block;
  padding-inline-start: var(--ids-space-3xs);
  font-size: 0;
  padding-block-start: var(--ids-space-3xs);
}
.ids-icon-button span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-icon-button.no-margins {
  margin-inline-start: var(--ids-space-none);
  margin-inline-end: var(--ids-space-none);
}

:host([field-height]) .ids-menu-button.field-height-lg {
  height: var(--ids-button-menu-field-height-lg);
}
:host([field-height]) .ids-menu-button.field-height-md {
  height: var(--ids-button-menu-field-height-md);
}
:host([field-height]) .ids-menu-button.field-height-sm {
  height: var(--ids-button-menu-field-height-sm);
}
:host([field-height]) .ids-menu-button.field-height-xs {
  height: var(--ids-button-menu-field-height-xs);
}

.ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-active:not([readonly]), .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-focused:not([readonly]), .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).focus-within:not([readonly]), .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus):focus:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-active:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-focused:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).focus-within:not([readonly]),
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus):focus:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-active:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).is-focused:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus).focus-within:not([readonly]),
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai):not(.hide-focus):focus:not([readonly]) {
  box-shadow: var(--ids-button-tertiary-shadow-focus);
}
.ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-active, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-focused, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).focus-within, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus):focus,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-active,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-focused,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).focus-within,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus):focus,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-active,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).is-focused,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus).focus-within,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate:not(.hide-focus):focus {
  box-shadow: var(--ids-box-shadow-inverse);
}
.ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-active, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-focused, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).focus-within, .ids-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-icon-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus):focus,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-active,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).is-focused,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus).focus-within,
.ids-menu-button:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai).color-variant-alternate-formatter:not(.hide-focus):focus {
  box-shadow: var(--ids-shadow-20);
}
.ids-button.btn-tertiary-destructive:not(.hide-focus).is-active, .ids-button.btn-tertiary-destructive:not(.hide-focus).is-focused, .ids-button.btn-tertiary-destructive:not(.hide-focus).focus-within, .ids-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-icon-button.btn-tertiary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-tertiary-destructive:not(.hide-focus):focus {
  box-shadow: var(--ids-button-destructive-tertiary-shadow-focus);
}
.ids-button.btn-primary:not(.hide-focus).is-active, .ids-button.btn-primary:not(.hide-focus).is-focused, .ids-button.btn-primary:not(.hide-focus).focus-within, .ids-button.btn-primary:not(.hide-focus):focus,
.ids-icon-button.btn-primary:not(.hide-focus).is-active,
.ids-icon-button.btn-primary:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary:not(.hide-focus):focus,
.ids-menu-button.btn-primary:not(.hide-focus).is-active,
.ids-menu-button.btn-primary:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary:not(.hide-focus):focus {
  box-shadow: var(--ids-button-primary-shadow-focus);
}
.ids-button.btn-primary.color-variant-alternate:not(.hide-focus).is-active, .ids-button.btn-primary.color-variant-alternate:not(.hide-focus).is-focused, .ids-button.btn-primary.color-variant-alternate:not(.hide-focus).focus-within, .ids-button.btn-primary.color-variant-alternate:not(.hide-focus):focus,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus).is-active,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary.color-variant-alternate:not(.hide-focus):focus,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus).is-active,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary.color-variant-alternate:not(.hide-focus):focus {
  box-shadow: 0 0 0 2px var(--ids-color-primary-70), 0 0 0 3px var(--ids-color-text-on-primary);
}
.ids-button.btn-primary-destructive:not(.hide-focus).is-active, .ids-button.btn-primary-destructive:not(.hide-focus).is-focused, .ids-button.btn-primary-destructive:not(.hide-focus).focus-within, .ids-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-icon-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-icon-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary-destructive:not(.hide-focus):focus,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-active,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary-destructive:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary-destructive:not(.hide-focus):focus {
  box-shadow: 0 0 0 2px var(--ids-color-background-default), 0 0 0 3px var(--ids-color-error-default);
}
.ids-button.btn-secondary:not(.hide-focus).is-active, .ids-button.btn-secondary:not(.hide-focus).is-focused, .ids-button.btn-secondary:not(.hide-focus).focus-within, .ids-button.btn-secondary:not(.hide-focus):focus,
.ids-icon-button.btn-secondary:not(.hide-focus).is-active,
.ids-icon-button.btn-secondary:not(.hide-focus).is-focused,
.ids-icon-button.btn-secondary:not(.hide-focus).focus-within,
.ids-icon-button.btn-secondary:not(.hide-focus):focus,
.ids-menu-button.btn-secondary:not(.hide-focus).is-active,
.ids-menu-button.btn-secondary:not(.hide-focus).is-focused,
.ids-menu-button.btn-secondary:not(.hide-focus).focus-within,
.ids-menu-button.btn-secondary:not(.hide-focus):focus {
  box-shadow: var(--ids-button-secondary-shadow-focus);
}
.ids-button.btn-primary-generative-ai:not(.hide-focus).is-active, .ids-button.btn-primary-generative-ai:not(.hide-focus).is-focused, .ids-button.btn-primary-generative-ai:not(.hide-focus).focus-within, .ids-button.btn-primary-generative-ai:not(.hide-focus):focus,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus).is-active,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus).is-focused,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus).focus-within,
.ids-icon-button.btn-primary-generative-ai:not(.hide-focus):focus,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus).is-active,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus).is-focused,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus).focus-within,
.ids-menu-button.btn-primary-generative-ai:not(.hide-focus):focus {
  box-shadow: var(--ids-button-ai-shadow-focus);
  border-color: var(--ids-color-transparent);
}
.ids-button.btn-tertiary-generative-ai:not(.hide-focus).is-active, .ids-button.btn-tertiary-generative-ai:not(.hide-focus).is-focused, .ids-button.btn-tertiary-generative-ai:not(.hide-focus).focus-within, .ids-button.btn-tertiary-generative-ai:not(.hide-focus):focus, .ids-button.btn-secondary-generative-ai:not(.hide-focus).is-active, .ids-button.btn-secondary-generative-ai:not(.hide-focus).is-focused, .ids-button.btn-secondary-generative-ai:not(.hide-focus).focus-within, .ids-button.btn-secondary-generative-ai:not(.hide-focus):focus,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus).is-active,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus).is-focused,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus).focus-within,
.ids-icon-button.btn-tertiary-generative-ai:not(.hide-focus):focus,
.ids-icon-button.btn-secondary-generative-ai:not(.hide-focus).is-active,
.ids-icon-button.btn-secondary-generative-ai:not(.hide-focus).is-focused,
.ids-icon-button.btn-secondary-generative-ai:not(.hide-focus).focus-within,
.ids-icon-button.btn-secondary-generative-ai:not(.hide-focus):focus,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus).is-active,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus).is-focused,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus).focus-within,
.ids-menu-button.btn-tertiary-generative-ai:not(.hide-focus):focus,
.ids-menu-button.btn-secondary-generative-ai:not(.hide-focus).is-active,
.ids-menu-button.btn-secondary-generative-ai:not(.hide-focus).is-focused,
.ids-menu-button.btn-secondary-generative-ai:not(.hide-focus).focus-within,
.ids-menu-button.btn-secondary-generative-ai:not(.hide-focus):focus {
  box-shadow: var(--ids-button-tertiary-ai-shadow-focus);
  border-color: var(--ids-button-ai-color-icon-secondary-hover);
}

.ids-modal-button:not(.ids-modal-icon-button) {
  box-shadow: var(--ids-shadow-none);
  font-weight: var(--ids-font-weight-normal);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
  overflow: hidden;
  padding-bottom: calc(var(--ids-space-xs) - 2px);
  padding-top: calc(var(--ids-space-xs) - 2px);
  position: relative;
  /* stylelint-disable-next-line no-duplicate-selectors */
}
.ids-modal-button:not(.ids-modal-icon-button), .ids-modal-button:not(.ids-modal-icon-button)::before, .ids-modal-button:not(.ids-modal-icon-button)::after {
  box-sizing: border-box;
}
.ids-modal-button:not(.ids-modal-icon-button) * {
  pointer-events: none;
}
.ids-modal-button:not(.ids-modal-icon-button) {
  border: 1px solid transparent;
  background-color: var(--ids-color-transparent);
  color: var(--ids-button-color-text-default);
  transition: background-color var(--ids-motion-duration) var(--ids-motion-ease), border-color var(--ids-motion-duration) var(--ids-motion-ease), color var(--ids-motion-duration) var(--ids-motion-ease), opacity var(--ids-motion-duration) var(--ids-motion-ease);
  white-space: nowrap;
}
.ids-modal-button:not(.ids-modal-icon-button):focus {
  outline: none;
  outline-color: var(--ids-color-transparent);
}
.ids-modal-button:not(.ids-modal-icon-button):not([disabled]) {
  cursor: var(--ids-cursor-pointer);
}
.ids-modal-button:not(.ids-modal-icon-button) span {
  vertical-align: bottom;
}
.ids-modal-button:not(.ids-modal-icon-button) span.audible {
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.ids-modal-button:not(.ids-modal-icon-button):not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon=genai])) {
  margin-inline-end: calc(var(--ids-space-2xs) + 3px);
}
.ids-modal-button:not(.ids-modal-icon-button) .ids-icon {
  vertical-align: middle;
}
.ids-modal-button:not(.ids-modal-icon-button).align-icon-end ::slotted(ids-icon) {
  margin-inline-start: var(--ids-space-2xs);
}
.ids-modal-button:not(.ids-modal-icon-button).content-align-start {
  justify-content: start;
}
.ids-modal-button:not(.ids-modal-icon-button).content-align-end {
  justify-content: end;
}
.ids-modal-button:not(.ids-modal-icon-button).no-margins {
  margin-inline: var(--ids-space-none);
}
.ids-modal-button:not(.ids-modal-icon-button).field-height-xxs:not(.btn-secondary):not(.no-margins) {
  margin-block-start: 3px;
  margin-inline-end: -2px;
  height: 22px;
  width: 22px;
}
.ids-modal-button:not(.ids-modal-icon-button) ::slotted(span) {
  font-weight: inherit !important;
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary {
  background-color: var(--ids-modal-color-background);
  color: var(--ids-modal-button-color-default);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus).is-active, .ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus).is-focused, .ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus).focus-within, .ids-modal-button:not(.ids-modal-icon-button).btn-primary:not(.hide-focus):focus {
  outline: 1px solid var(--ids-modal-color-outline);
  outline-offset: -1px;
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary:hover:not([disabled]) {
  color: var(--ids-modal-button-color-hover);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-primary[disabled] {
  opacity: var(--ids-button-primary-opacity-disabled);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary {
  background-color: var(--ids-modal-color-background);
  color: var(--ids-modal-button-secondary-color-default);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus).is-active, .ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus).is-focused, .ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus).focus-within, .ids-modal-button:not(.ids-modal-icon-button).btn-secondary:not(.hide-focus):focus, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus).is-active, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus).is-focused, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus).focus-within, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:not(.hide-focus):focus {
  outline: 1px solid var(--ids-modal-color-outline);
  outline-offset: -1px;
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary:hover, .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary:hover {
  color: var(--ids-modal-button-secondary-color-hover);
}
.ids-modal-button:not(.ids-modal-icon-button).btn-secondary[disabled], .ids-modal-button:not(.ids-modal-icon-button).btn-tertiary[disabled] {
  opacity: var(--ids-button-secondary-opacity-disabled);
}
.ids-modal-button:not(.ids-modal-icon-button) {
  padding-block-start: var(--ids-space-12);
  padding-block-end: var(--ids-space-12);
  display: block;
  font-weight: var(--ids-font-weight-strong);
  justify-content: center;
  height: 100%;
  width: 100%;
}
.ids-modal-button:not(.ids-modal-icon-button):focus {
  z-index: 1;
}

.ids-modal-icon-button {
  padding: var(--ids-space-xs);
}

.btn-swipe-action-left,
.btn-swipe-action-right {
  display: block;
  padding: 0 var(--ids-space-xs) var(--ids-space-xs);
  height: 100%;
  margin: 0;
  white-space: inherit;
  width: 85px;
}
.btn-swipe-action-left ::slotted(ids-icon),
.btn-swipe-action-right ::slotted(ids-icon) {
  display: block;
}
.btn-swipe-action-left:hover, .btn-swipe-action-left:focus,
.btn-swipe-action-right:hover,
.btn-swipe-action-right:focus {
  box-shadow: none;
  border-color: var(--ids-color-transparent);
}

.ids-button:not(.no-margins).btn-swipe-action-left,
.ids-button:not(.no-margins).btn-swipe-action-right {
  margin: 0;
}

.btn-swipe-action-left {
  border-start-end-radius: var(--ids-border-radius-none);
  border-end-end-radius: var(--ids-border-radius-none);
  background-color: var(--ids-swipe-action-color-background-left);
  color: var(--ids-swipe-action-color-text-left);
}
.btn-swipe-action-left:active {
  background-color: var(--ids-swipe-action-color-background-left-active);
  color: var(--ids-swipe-action-color-text-left-active);
}
.btn-swipe-action-left:hover {
  background-color: var(--ids-swipe-action-color-background-left-hover);
  color: var(--ids-swipe-action-color-text-left-hover);
}

.btn-swipe-action-right {
  border-start-start-radius: var(--ids-border-radius-none);
  border-end-start-radius: var(--ids-border-radius-none);
  background-color: var(--ids-swipe-action-color-background-right);
  color: var(--ids-swipe-action-color-text-right);
}
.btn-swipe-action-right:active {
  background-color: var(--ids-swipe-action-color-background-right-active);
  color: var(--ids-swipe-action-color-text-right-active);
}
.btn-swipe-action-right:hover {
  background-color: var(--ids-swipe-action-color-background-right-hover);
  color: var(--ids-swipe-action-color-text-right-hover);
}

.ids-icon-button.gen-ai-active:not(.no-animation) ::slotted(ids-icon[icon=genai]),
.ids-button.gen-ai-active:not(.no-animation) ::slotted(ids-icon[icon=genai]) {
  display: none;
}
.ids-icon-button.gen-ai-active:not(.no-animation) .loading-dots,
.ids-button.gen-ai-active:not(.no-animation) .loading-dots {
  display: flex;
}

.ids-icon-button.gen-ai-active .loading-dots {
  padding-inline-start: 3px;
  padding-inline-end: var(--ids-space-3xs);
  padding-block-start: 7px;
  padding-block-end: var(--ids-space-xs);
}

.ids-button ::slotted(ids-icon[icon=genai]:first-child),
.ids-toggle-button ::slotted(ids-icon[icon=genai]:first-child),
.ids-menu-button:not(.ids-icon-button) ::slotted(ids-icon[icon=genai]:first-child),
.ids-modal-button:not(.ids-icon-button) ::slotted(ids-icon[icon=genai]:first-child) {
  margin-inline-end: 5px;
}
.ids-button ::slotted(ids-icon:not(:first-child)),
.ids-toggle-button ::slotted(ids-icon:not(:first-child)),
.ids-menu-button:not(.ids-icon-button) ::slotted(ids-icon:not(:first-child)),
.ids-modal-button:not(.ids-icon-button) ::slotted(ids-icon:not(:first-child)) {
  margin-inline-start: 5px;
  margin-inline-end: var(--ids-space-none);
}
.ids-button .ids-icon:last-child,
.ids-button span + span:not(.audible),
.ids-button span:not(.audible):last-child,
.ids-toggle-button .ids-icon:last-child,
.ids-toggle-button span + span:not(.audible),
.ids-toggle-button span:not(.audible):last-child,
.ids-menu-button:not(.ids-icon-button) .ids-icon:last-child,
.ids-menu-button:not(.ids-icon-button) span + span:not(.audible),
.ids-menu-button:not(.ids-icon-button) span:not(.audible):last-child,
.ids-modal-button:not(.ids-icon-button) .ids-icon:last-child,
.ids-modal-button:not(.ids-icon-button) span + span:not(.audible),
.ids-modal-button:not(.ids-icon-button) span:not(.audible):last-child {
  padding-inline-start: 5px;
}

.ids-modal-button ::slotted(ids-icon:not(:first-child)) {
  padding: var(--ids-space-3xs);
}

:host(:not([show-loading-indicator=true])) ::slotted(.slot-loading-indicator) {
  display: none;
}

:host([show-loading-indicator=true]) ::slotted(ids-loading-indicator) {
  margin-top: 3px;
  margin-bottom: 3px;
}

:host([show-loading-indicator=true][loading-indicator-only=true]) ::slotted(*:not(.slot-loading-indicator)) {
  visibility: hidden;
}

:host([show-loading-indicator=true]:not([loading-indicator-only=true])) ::slotted(.slot-loading-indicator) {
  margin-inline-start: 6px;
}

:host([show-loading-indicator=true]:not([loading-indicator-only=true]):is([appearance=primary], [appearance=secondary], [appearance=primary-destructive]))::part(button) {
  padding-inline-start: 20px;
  padding-inline-end: 12px;
}
:host([show-loading-indicator=true]:not([loading-indicator-only=true]):is([appearance=primary], [appearance=secondary], [appearance=primary-destructive])) ::slotted(.slot-loading-indicator) {
  margin-inline-start: 10px;
}

:host([loading-indicator-only=true]) ::slotted(.slot-loading-indicator) {
  position: absolute;
  margin-inline-start: auto;
  margin-inline-end: auto;
  left: var(--ids-space-none);
  right: var(--ids-space-none);
}

:host(ids-toggle-button:not(.dropdown-btn)) {
  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-default);
  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-default);
}

:host(ids-toggle-button[pressed]) {
  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-default);
}

:host(ids-toggle-button[color=orange]) {
  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-orange);
  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-orange);
}

:host(ids-toggle-button[pressed][color=orange]) {
  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-orange);
}

:host(ids-toggle-button[color=red]) {
  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-red);
  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-red);
}

:host(ids-toggle-button[pressed][color=red]) {
  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-red);
}

:host(ids-toggle-button.ids-toggle-button-segmented) button {
  border-radius: var(--ids-border-radius-sm);
  font-weight: var(--ids-font-weight-normal);
}
:host(ids-toggle-button.ids-toggle-button-segmented) button:hover {
  color: var(--ids-segmented-control-text-color);
  background-color: var(--ids-segmented-control-background-hover);
}

:host(ids-toggle-button.ids-toggle-button-segmented[pressed]) button {
  color: var(--ids-segmented-control-text-color);
  background-color: var(--ids-segmented-control-background-selected);
  box-shadow: var(--ids-segmented-control-box-shadow);
  border-color: transparent;
}

:host button {
  --ids-button-icon-height: 32px;
  --ids-button-icon-width: 32px;
  height: auto;
  width: auto;
}

:host(.expand-button) button {
  --ids-button-icon-height: 34px;
  --ids-button-icon-width: 34px;
  margin-top: -2px;
}

:host([compact]) .ids-trigger-button.ids-icon-button,
:host([field-height=xs]) .ids-trigger-button.ids-icon-button,
:host([field-height=sm]) .ids-trigger-button.ids-icon-button {
  --ids-button-icon-height: 26px;
  --ids-button-icon-width: 26px;
  padding: var(--ids-space-none);
}
:host([compact]) .ids-trigger-button.ids-icon-button:not(.square),
:host([field-height=xs]) .ids-trigger-button.ids-icon-button:not(.square),
:host([field-height=sm]) .ids-trigger-button.ids-icon-button:not(.square) {
  border-radius: var(--ids-trigger-field-button-border-radius);
}

:host([field-height=xs]) .ids-trigger-button.ids-icon-button,
:host([field-height=xxs]) .ids-trigger-button.ids-icon-button {
  margin-inline-end: 3px;
}
:host([field-height=xs]) .ids-trigger-button.ids-icon-button.color-variant-borderless[aria-label=DropdownTriggerButton],
:host([field-height=xxs]) .ids-trigger-button.ids-icon-button.color-variant-borderless[aria-label=DropdownTriggerButton] {
  margin-inline-end: 0;
}
:host([field-height=xs]) .ids-trigger-button.ids-icon-button.color-variant-borderless,
:host([field-height=xxs]) .ids-trigger-button.ids-icon-button.color-variant-borderless {
  margin-inline-end: 3px;
  height: 22px;
  width: 22px;
}
:host([field-height=xs]) .ids-trigger-button.ids-icon-button.color-variant-in-cell,
:host([field-height=xxs]) .ids-trigger-button.ids-icon-button.color-variant-in-cell {
  margin-inline-end: -3px;
  margin-block-start: 2px;
}

:host([field-height=xxs]) .ids-trigger-button.ids-icon-button.color-variant-borderless[aria-label=DropdownTriggerButton] {
  margin-inline-end: -1px;
  margin-block-start: 3px;
}
:host([field-height=xxs]) .ids-trigger-button.ids-icon-button.color-variant-in-cell {
  margin-inline-end: 0;
  margin-block-start: 2px;
}

:host([field-height=sm]) .ids-trigger-button.ids-icon-button {
  margin-inline-end: 2px;
}
:host([field-height=sm]) .ids-trigger-button.ids-icon-button.color-variant-borderless {
  margin-inline-end: -2px;
  height: 24px;
  width: 24px;
}
:host([field-height=sm]) .ids-trigger-button.ids-icon-button.color-variant-borderless[aria-label=DropdownTriggerButton] {
  margin-inline-end: -4px;
}
:host([field-height=sm]) .ids-trigger-button.ids-icon-button.color-variant-borderless.no-margins {
  margin-inline-start: 2px;
}
:host([field-height=sm]) .ids-trigger-button.ids-icon-button.color-variant-in-cell {
  margin-inline-end: -3px;
  margin-block-start: 1px;
}

:host([field-height=md]) .ids-trigger-button.ids-icon-button.color-variant-borderless {
  margin-inline-end: -11px;
  height: 30px;
  width: 30px;
}
:host([field-height=md]) .ids-trigger-button.ids-icon-button.color-variant-borderless.no-margins {
  margin-inline-start: 2px;
}
:host([field-height=md]) .ids-trigger-button.ids-icon-button.color-variant-in-cell {
  margin-inline-end: -4px;
  margin-block-start: 1px;
}

:host(.expand-button),
.expand-button {
  --ids-button-height: 36px;
  --ids-button-width: 36px;
  height: var(--ids-button-height);
  width: var(--ids-button-width);
}

.ids-trigger-button {
  align-items: center;
  background-color: var(--ids-color-transparent);
  display: flex;
  color: var(--ids-trigger-field-icon-color);
  justify-content: center;
}
.ids-trigger-button.ids-icon-button {
  padding: var(--ids-space-2xs);
}
.ids-trigger-button.ids-icon-button.ids-sub-tab-close-button {
  margin-inline-end: 3px;
  width: var(--ids-button-icon-third-width);
  height: var(--ids-button-icon-third-height);
}
.ids-trigger-button.ids-icon-button:not(.ids-tab-close-button):not(.ids-sub-tab-close-button) {
  inset-inline-start: 2px;
}
.ids-trigger-button.ids-icon-button[disabled] {
  color: var(--ids-trigger-field-color-text-disabled);
}
.ids-trigger-button.ids-icon-button[readonly] {
  color: var(--ids-trigger-field-color-text-disabled);
  opacity: var(--ids-button-tertiary-opacity-disabled);
}
.ids-trigger-button.ids-icon-button[readonly]:hover {
  cursor: default;
  background-color: var(--ids-color-transparent);
  border-color: var(--ids-color-transparent);
}
.ids-trigger-button.ids-icon-button.ids-tab-close-button:not(.no-padding):not(.sub-tab-button):not(.compact) {
  padding: 0;
  width: var(--ids-button-icon-third-width);
  height: var(--ids-button-icon-third-height);
}
.ids-trigger-button.style-inline {
  border: 0;
  padding: var(--ids-space-none);
  border-radius: var(--ids-trigger-field-button-border-radius-inline);
  margin: var(--ids-space-none);
}
.ids-trigger-button.style-inline.ids-icon-button {
  padding: var(--ids-space-none);
}
.ids-trigger-button.style-inline.square {
  border-radius: 0;
}
.ids-trigger-button.style-inline.field-height-xs, .ids-trigger-button.style-inline.field-height-xs.compact {
  height: calc(var(--ids-input-height-10) - 2px);
  width: calc(var(--ids-input-height-10) - 2px);
}
.ids-trigger-button.style-inline.field-height-sm {
  height: calc(var(--ids-input-height-20) - 2px);
  width: calc(var(--ids-input-height-20) - 2px);
}
.ids-trigger-button.style-inline.field-height-md {
  height: calc(var(--ids-input-height-30) - 2px);
  width: calc(var(--ids-input-height-30) - 2px);
}
.ids-trigger-button.style-inline.field-height-lg {
  height: calc(var(--ids-input-height-40) - 2px);
  width: calc(var(--ids-input-height-40) - 2px);
}
.ids-trigger-button.style-inline.compact, .ids-trigger-button.style-inline.field-height-sm.compact, .ids-trigger-button.style-inline.field-height-md.compact, .ids-trigger-button.style-inline.field-height-lg.compact {
  height: calc(var(--ids-input-height-10) - 2px);
}
.ids-trigger-button.inline-end {
  border-inline-start: 1px solid;
}
.ids-trigger-button.inline-start {
  border-inline-end: 1px solid;
}
.ids-trigger-button.inline-start:not(.btn-secondary):not(.no-margins) {
  margin: 0;
}
.ids-trigger-button.color-variant-alternate-formatter {
  padding: var(--ids-space-3xs);
}
.ids-trigger-button.inherit-color {
  color: currentColor;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-button/ids-button.scss","webpack://./src/components/ids-button/ids-button-base.scss","webpack://./src/components/ids-trigger-field/ids-trigger-button.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAAA;;;EAAA;ACAA;;EAAA;AAiIA;;EAAA;AAWA;;EAAA;AA2fA;;EAAA;ADhoBA;EACE,oBAAA;EACA,sBAAA;AEUF;AFRE;EACE,sBAAA;AEUJ;AFPE;;EAEE,mBAAA;EACA,kBAAA;AESJ;AFNE;EACE,sBAAA;EACA,mBAAA;AEQJ;AFLE;EACE,uCAAA;AEOJ;AFJE;EGPA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;ADcF;AFTE;;EAEE,uBAAA;EACA,YAAA;EACA,WAAA;AEWJ;;AFPA;EACE,aAAA;AEUF;;AFNE;EACE,8CAAA;EACA,0CAAA;EACA,gDAAA;AESJ;;AFLA;EACE,aAAA;AEQF;;AFJA;EACE,cAAA;AEOF;;AFDA;;;;EGzDE,mCAAA;EACA,kCAAA;ADiEF;AFHE;;;;EACE,oBAAA;EACA,kBAAA;EACA,sBAAA;AEQJ;;AFFE;;EACE,mCAAA;EACA,uCAAA;EACA,iBAAA;AEMJ;;AFDE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AEIJ;;AFAA;;;EC9FE,kCAAA;EAwBA,0CAAA;EACA,+EAAA;EACA,kCAAA;EACA,gBAAA;EACA,+CAAA;EACA,4CAAA;EACA,kBAAA;AC6EF;AD3EE;;;;;;;EAGE,sBAAA;ACiFJ;AD7EE;;;EACE,oBAAA;ACiFJ;AD3EE;;;EACE,6BAAA;EACA,8CAAA;EACA,2CAAA;EAGA,kQACE;EAIF,mBAAA;ACyEJ;ADtEE;;;EAEE,aAAA;EACA,2CAAA;ACyEJ;ADtEE;;;EACC,iCAAA;AC0EH;ADrEE;;;EACE,sBAAA;ACyEJ;ADvEI;;;EE3DF,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;ADuIF;AD9EE;;;EACE,mDAAA;ACkFJ;AD/EE;;;EACE,sBAAA;ACmFJ;AD5EI;;;EACE,yCAAA;ACgFN;AD5EE;;;EACE,sBAAA;ACgFJ;AD7EE;;;EACE,oBAAA;ACiFJ;AD9EE;;;EACE,oCAAA;ACkFJ;AD/EE;;;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;ACmFJ;ADhFE;;;EAEE,+BAAA;ACmFJ;ADhEE;;;EACE,oBAAA;EACA,mDAAA;EACA,uCAAA;EAIA,qEAAA;EACA,6DAAA;EACA,oDAAA;ACiEJ;AD1DI;;;;;;;;;EACE,2DAAA;ACoEN;ADhEE;;;EACE,kDAAA;EACA,mEAAA;EACA,2DAAA;ACoEJ;ADjEE;;;EACE,qDAAA;EACA,sEAAA;EACA,8DAAA;EACA,oDAAA;ACqEJ;ADlEE;;;EACE,qEAAA;EACA,6DAAA;EACA,oDAAA;ACsEJ;ADjEE;;;EACE,iFAAA;EACA,yEAAA;EACA,gEAAA;ACqEJ;ADnEI;;;;;;;;;EAIE,uEAAA;AC0EN;ADvEI;;;EACE,+EAAA;EACA,uEAAA;EACA,8DAAA;AC2EN;ADxEI;;;EACE,iEAAA;EACA,kFAAA;EACA,0EAAA;AC4EN;ADrEE;;;EACE,oEAAA;EACA,4DAAA;EACA,gEAAA;EACA,mDAAA;EACA,+CAAA;EACA,4CAAA;ACyEJ;ADvEI;;;;;;;;;EAIE,0DAAA;AC8EN;AD3EI;;;EACE,kEAAA;EACA,0DAAA;AC+EN;AD5EI;;;EACE,qEAAA;EACA,6DAAA;EACA,oDAAA;EACA,mDAAA;ACgFN;AD7EI;;;EACE,oEAAA;EACA,4DAAA;EACA,mDAAA;ACiFN;AD1EE;;;EACE,wEAAA;EACA,gEAAA;EACA,uDAAA;AC8EJ;AD5EI;;;;;;;;;EAIE,8DAAA;ACmFN;ADhFI;;;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;ACoFN;ADjFI;;;EACE,yEAAA;EACA,iEAAA;EACA,wDAAA;EACA,uDAAA;ACqFN;AD/EE;EACE;IACE,uEAAA;ECiFJ;ED9EE;IAEI,uEAAA;EC+EN;AACF;AD5EE;EACE;IACE,yEAAA;EC8EJ;ED3EE;IAEI,yEAAA;EC4EN;AACF;ADzEE;EACE;IACE,wEAAA;EC2EJ;EDxEE;IAEI,wEAAA;ECyEN;AACF;ADtEE;;;EACE,oCAAA;EACA,kCAAA;EACA,QAAA;AC0EJ;ADvEE;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,uBAAA;AC2EJ;ADzEI;;;EACE,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gEAAA;EACA,qDAAA;AC6EN;ADzEE;;;EACE,6FAAA;EAEA,oEAAA;EACA,YAAA;EACA,8CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AC4EJ;AD1EI;;;EACE,0CAAA;EACA,2CAAA;AC8EN;AD3EI;;;EACE,kEAAA;AC+EN;AD5EI;;;;;EAEE,mEAAA;EACA,6CAAA;ACiFN;AD9EI;;;EACE,qEAAA;ACkFN;AD/EI;;;;;EAEE,iCAAA;EACA,4CAAA;EACA,eAAA;ACoFN;ADhFM;;;EACE,6CAAA;EACA,mBAAA;ACoFR;ADjFM;;;EACE,oDAAA;EACA,qBAAA;ACqFR;ADlFM;;;EACE,6CAAA;EACA,mBAAA;ACsFR;AD/EE;;;EACE,+FAAA;EAEA,mEAAA;EACA,qEAAA;EACA,mDAAA;EACA,mBAAA;ACkFJ;ADhFI;;;EACE,iEAAA;EACA,iDAAA;EACA,+DAAA;ACoFN;ADjFI;;;EACE,kEAAA;EACA,kDAAA;EACA,gEAAA;ACqFN;ADlFI;;;EACE,iFAAA;EACA,qFAAA;ACsFN;ADnFI;;;EACE,kEAAA;ACuFN;ADpFI;;;EACE,8CAAA;ACwFN;ADnFM;;;EACE,kEAAA;EACA,uDAAA;ACuFR;ADpFM;;;EACE,8DAAA;EACA,mBAAA;ACwFR;ADrFM;;;EACE,qEAAA;EACA,qBAAA;ACyFR;ADtFM;;;EACE,8DAAA;EACA,mBAAA;AC0FR;ADnFE;;;EACE,8EAAA;EACA,4EAAA;EACA,8FAAA;EAEA,kEAAA;EACA,qBAAA;EACA,mBAAA;EACA,uDAAA;ACsFJ;ADpFI;;;EACE,gEAAA;ACwFN;ADrFI;;;EACE,oFAAA;EACA,sFAAA;ACyFN;ADtFI;;;;;EAEE,iEAAA;AC2FN;ADxFI;;;EACE,mEAAA;EACA,8CAAA;AC4FN;ADvFM;;;EACE,6DAAA;EACA,mBAAA;AC2FR;ADxFM;;;EACE,oEAAA;EACA,qBAAA;AC4FR;ADzFM;;;EACE,6DAAA;EACA,mBAAA;AC6FR;ADtFE;;;EACE,sEAAA;EACA,sDAAA;EACA,8DAAA;EACA,qDAAA;AC0FJ;ADxFI;;;;;;;;;EAIE,oEAAA;EACA,4DAAA;AC+FN;AD5FI;;;EACE,oEAAA;EACA,4DAAA;EACA,mDAAA;ACgGN;AD7FI;;;EACE,uEAAA;EACA,+DAAA;EACA,sDAAA;EACA,qDAAA;ACiGN;AD9FI;;;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;ACkGN;ADxFI;;;EACE,oCAAA;AC4FN;ADxFM;;;EACE,iEAAA;AC4FR;ADrFI;;;EACE,2CAAA;ACyFN;ADpFE;;;;;EAEE,qDAAA;EACA,YAAA;ACyFJ;ADvFI;;;;;;;;;;;;;;;;;EAIE,4DAAA;EACA,UAAA;ACsGN;ADnGI;;;;;EACE,oEAAA;EACA,0CAAA;EACA,mDAAA;EACA,UAAA;ACyGN;ADtGI;;;;;EACE,8CAAA;EACA,qDAAA;AC4GN;ADvGE;;;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;EACA,wCAAA;EACA,2CAAA;AC2GJ;ADzGI;;;;;;;;;EAIE,2CAAA;ACgHN;AD7GI;;;EACE,sDAAA;ACiHN;AD9GI;;;EACE,oEAAA;EACA,mDAAA;ACkHN;AD/GI;;;EACE,+CAAA;ACmHN;ADhHI;;;EACE,6BAAA;EACA,oCAAA;ACoHN;ADlHM;;;EACE,0CAAA;EACA,WAAA;ACsHR;ADlHI;;;;;EAEE,6BAAA;ACuHN;ADlHE;;;EACE,SAAA;EACA,kDAAA;ACsHJ;ADpHI;;;EACE,qDAAA;ACwHN;ADrHI;;;EACE,iEAAA;EACA,gDAAA;ACyHN;AF9oBE;;;ECwBA,gDAAA;AC2nBF;AF/oBE;;;;;ECwBA,mCAAA;AC8nBF;AFjpBE;;;ECmBA,mCAAA;ACmoBF;;AFjpBA;EACE,uBAAA;AEopBF;;AFjpBA;;EAEE,gEAAA;EACA,+CAAA;AEopBF;;AFhpBE;EACE,qDAAA;EACA,mDAAA;AEmpBJ;AFhpBE;EACE,uBAAA;AEkpBJ;AFhpBI;EACE,kBAAA;EACA,sCAAA;AEkpBN;;AF5oBA;EACE,YAAA;EACA,YAAA;AE+oBF;;AF5oBA;ECpJE,kCAAA;EAwBA,0CAAA;EACA,+EAAA;EACA,kCAAA;EACA,gBAAA;EACA,+CAAA;EACA,4CAAA;EACA,kBAAA;ED2HA,uDAAA;AEmpBF;AD5wBE;EAGE,sBAAA;AC4wBJ;ADxwBE;EACE,oBAAA;AC0wBJ;ADpwBE;EACE,6BAAA;EACA,8CAAA;EACA,2CAAA;EAGA,kQACE;EAIF,mBAAA;ACgwBJ;AD7vBE;EAEE,aAAA;EACA,2CAAA;AC8vBJ;AD3vBE;EACC,iCAAA;AC6vBH;ADxvBE;EACE,sBAAA;AC0vBJ;ADxvBI;EE3DF,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;ADszBF;AD7vBE;EACE,mDAAA;AC+vBJ;AD5vBE;EACE,sBAAA;AC8vBJ;ADvvBI;EACE,yCAAA;ACyvBN;ADrvBE;EACE,sBAAA;ACuvBJ;ADpvBE;EACE,oBAAA;ACsvBJ;ADnvBE;EACE,oCAAA;ACqvBJ;ADlvBE;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;ACovBJ;ADjvBE;EAEE,+BAAA;ACkvBJ;AD/tBE;EACE,oBAAA;EACA,mDAAA;EACA,uCAAA;EAIA,qEAAA;EACA,6DAAA;EACA,oDAAA;AC8tBJ;ADvtBI;EACE,2DAAA;ACytBN;ADrtBE;EACE,kDAAA;EACA,mEAAA;EACA,2DAAA;ACutBJ;ADptBE;EACE,qDAAA;EACA,sEAAA;EACA,8DAAA;EACA,oDAAA;ACstBJ;ADntBE;EACE,qEAAA;EACA,6DAAA;EACA,oDAAA;ACqtBJ;ADhtBE;EACE,iFAAA;EACA,yEAAA;EACA,gEAAA;ACktBJ;ADhtBI;EAIE,uEAAA;AC+sBN;AD5sBI;EACE,+EAAA;EACA,uEAAA;EACA,8DAAA;AC8sBN;AD3sBI;EACE,iEAAA;EACA,kFAAA;EACA,0EAAA;AC6sBN;ADtsBE;EACE,oEAAA;EACA,4DAAA;EACA,gEAAA;EACA,mDAAA;EACA,+CAAA;EACA,4CAAA;ACwsBJ;ADtsBI;EAIE,0DAAA;ACqsBN;ADlsBI;EACE,kEAAA;EACA,0DAAA;ACosBN;ADjsBI;EACE,qEAAA;EACA,6DAAA;EACA,oDAAA;EACA,mDAAA;ACmsBN;ADhsBI;EACE,oEAAA;EACA,4DAAA;EACA,mDAAA;ACksBN;AD3rBE;EACE,wEAAA;EACA,gEAAA;EACA,uDAAA;AC6rBJ;AD3rBI;EAIE,8DAAA;AC0rBN;ADvrBI;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;ACyrBN;ADtrBI;EACE,yEAAA;EACA,iEAAA;EACA,wDAAA;EACA,uDAAA;ACwrBN;ADlrBE;EACE;IACE,uEAAA;ECorBJ;EDjrBE;IAEI,uEAAA;ECkrBN;AACF;AD/qBE;EACE;IACE,yEAAA;ECirBJ;ED9qBE;IAEI,yEAAA;EC+qBN;AACF;AD5qBE;EACE;IACE,wEAAA;EC8qBJ;ED3qBE;IAEI,wEAAA;EC4qBN;AACF;ADzqBE;EACE,oCAAA;EACA,kCAAA;EACA,QAAA;AC2qBJ;ADxqBE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,uBAAA;AC0qBJ;ADxqBI;EACE,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gEAAA;EACA,qDAAA;AC0qBN;ADtqBE;EACE,6FAAA;EAEA,oEAAA;EACA,YAAA;EACA,8CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ACuqBJ;ADrqBI;EACE,0CAAA;EACA,2CAAA;ACuqBN;ADpqBI;EACE,kEAAA;ACsqBN;ADnqBI;EAEE,mEAAA;EACA,6CAAA;ACoqBN;ADjqBI;EACE,qEAAA;ACmqBN;ADhqBI;EAEE,iCAAA;EACA,4CAAA;EACA,eAAA;ACiqBN;AD7pBM;EACE,6CAAA;EACA,mBAAA;AC+pBR;AD5pBM;EACE,oDAAA;EACA,qBAAA;AC8pBR;AD3pBM;EACE,6CAAA;EACA,mBAAA;AC6pBR;ADtpBE;EACE,+FAAA;EAEA,mEAAA;EACA,qEAAA;EACA,mDAAA;EACA,mBAAA;ACupBJ;ADrpBI;EACE,iEAAA;EACA,iDAAA;EACA,+DAAA;ACupBN;ADppBI;EACE,kEAAA;EACA,kDAAA;EACA,gEAAA;ACspBN;ADnpBI;EACE,iFAAA;EACA,qFAAA;ACqpBN;ADlpBI;EACE,kEAAA;ACopBN;ADjpBI;EACE,8CAAA;ACmpBN;AD9oBM;EACE,kEAAA;EACA,uDAAA;ACgpBR;AD7oBM;EACE,8DAAA;EACA,mBAAA;AC+oBR;AD5oBM;EACE,qEAAA;EACA,qBAAA;AC8oBR;AD3oBM;EACE,8DAAA;EACA,mBAAA;AC6oBR;ADtoBE;EACE,8EAAA;EACA,4EAAA;EACA,8FAAA;EAEA,kEAAA;EACA,qBAAA;EACA,mBAAA;EACA,uDAAA;ACuoBJ;ADroBI;EACE,gEAAA;ACuoBN;ADpoBI;EACE,oFAAA;EACA,sFAAA;ACsoBN;ADnoBI;EAEE,iEAAA;ACooBN;ADjoBI;EACE,mEAAA;EACA,8CAAA;ACmoBN;AD9nBM;EACE,6DAAA;EACA,mBAAA;ACgoBR;AD7nBM;EACE,oEAAA;EACA,qBAAA;AC+nBR;AD5nBM;EACE,6DAAA;EACA,mBAAA;AC8nBR;ADvnBE;EACE,sEAAA;EACA,sDAAA;EACA,8DAAA;EACA,qDAAA;ACynBJ;ADvnBI;EAIE,oEAAA;EACA,4DAAA;ACsnBN;ADnnBI;EACE,oEAAA;EACA,4DAAA;EACA,mDAAA;ACqnBN;ADlnBI;EACE,uEAAA;EACA,+DAAA;EACA,sDAAA;EACA,qDAAA;AConBN;ADjnBI;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;ACmnBN;ADzmBI;EACE,oCAAA;AC2mBN;ADvmBM;EACE,iEAAA;ACymBR;ADlmBI;EACE,2CAAA;AComBN;AD/lBE;EAEE,qDAAA;EACA,YAAA;ACgmBJ;AD9lBI;EAIE,4DAAA;EACA,UAAA;AC6lBN;AD1lBI;EACE,oEAAA;EACA,0CAAA;EACA,mDAAA;EACA,UAAA;AC4lBN;ADzlBI;EACE,8CAAA;EACA,qDAAA;AC2lBN;ADtlBE;EACE,sEAAA;EACA,8DAAA;EACA,qDAAA;EACA,wCAAA;EACA,2CAAA;ACwlBJ;ADtlBI;EAIE,2CAAA;ACqlBN;ADllBI;EACE,sDAAA;AColBN;ADjlBI;EACE,oEAAA;EACA,mDAAA;ACmlBN;ADhlBI;EACE,+CAAA;ACklBN;AD/kBI;EACE,6BAAA;EACA,oCAAA;ACilBN;AD/kBM;EACE,0CAAA;EACA,WAAA;ACilBR;AD7kBI;EAEE,6BAAA;AC8kBN;ADzkBE;EACE,SAAA;EACA,kDAAA;AC2kBJ;ADzkBI;EACE,qDAAA;AC2kBN;ADxkBI;EACE,iEAAA;EACA,gDAAA;AC0kBN;AF3iCE;EACE,oDAAA;EACA,kDAAA;EACA,mDAAA;EACA,iDAAA;AE6iCJ;AF1iCE;EACE,oDAAA;EACA,kDAAA;EACA,2CAAA;EACA,8CAAA;AE4iCJ;AF1iCI;EAGE,qCAAA;EACA,mCAAA;AE0iCN;AFtiCE;EACE,UAAA;AEwiCJ;AFpiCI;EACE,0DAAA;EACA,uDAAA;AEsiCN;AFliCE;EACE,qDAAA;AEoiCJ;AFliCI;EACE,yBAAA;AEoiCN;AFhiCE;EACE,uCAAA;AEkiCJ;AF/hCE;EACE,4CAAA;AEiiCJ;AF9hCM;EACE,UAAA;AEgiCR;AF3hCE;EACE,cAAA;EACA,0CAAA;EACA,YAAA;EACA,yCAAA;AE6hCJ;AF1hCE;EGvMA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;ADouCF;AFhiCE;EACE,0CAAA;EACA,wCAAA;AEkiCJ;;AF5hCI;EACE,8CAAA;AE+hCN;AF5hCI;EACE,8CAAA;AE8hCN;AF3hCI;EACE,8CAAA;AE6hCN;AF1hCI;EACE,8CAAA;AE4hCN;;ADjoBM;;;;;;;;;EACE,mDAAA;AC4oBR;ADvoBM;;;;;;;;;EAIE,yCAAA;AC8oBR;ADzoBM;;;;;;;;;EAIE,gCAAA;ACgpBR;AD1oBI;;;;;;;;;EAIE,+DAAA;ACipBN;AD1oBI;;;;;;;;;EAIE,kDAAA;ACipBN;AD7oBM;;;;;;;;;EAlrBJ,6FACE;ACy0CJ;ADzoBI;;;;;;;;;EAjsBF,mGACE;ACo1CJ;ADtoBI;;;;;;;;;EAIE,oDAAA;AC6oBN;ADxoBI;;;;;;;;;EAIE,6CAAA;EACA,0CAAA;AC+oBN;ADzoBI;;;;;;;;;;;;;;;;;EAIE,sDAAA;EACA,6DAAA;ACwpBN;;AFvoCA;EC9PE,kCAAA;EAwBA,0CAAA;EACA,+EAAA;EACA,kCAAA;EACA,gBAAA;EACA,+CAAA;EACA,4CAAA;EACA,kBAAA;EDoOA,uDAAA;AE+oCF;ADj3CE;EAGE,sBAAA;ACi3CJ;AD72CE;EACE,oBAAA;AC+2CJ;ADz2CE;EACE,6BAAA;EACA,8CAAA;EACA,2CAAA;EAGA,kQACE;EAIF,mBAAA;ACq2CJ;ADl2CE;EAEE,aAAA;EACA,2CAAA;ACm2CJ;ADh2CE;EACC,iCAAA;ACk2CH;AD71CE;EACE,sBAAA;AC+1CJ;AD71CI;EE3DF,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AD25CF;ADl2CE;EACE,mDAAA;ACo2CJ;ADj2CE;EACE,sBAAA;ACm2CJ;AD51CI;EACE,yCAAA;AC81CN;AD11CE;EACE,sBAAA;AC41CJ;ADz1CE;EACE,oBAAA;AC21CJ;ADx1CE;EACE,oCAAA;AC01CJ;ADv1CE;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;ACy1CJ;ADt1CE;EAEE,+BAAA;ACu1CJ;ADxtBE;EACE,mDAAA;EACA,4CAAA;AC0tBJ;ADxtBI;EA7uBF,iDAAA;EACA,oBAAA;ACw8CF;ADrtBI;EACE,0CAAA;ACutBN;ADptBI;EACE,mDAAA;ACstBN;AD/sBE;EAEE,mDAAA;EACA,sDAAA;ACgtBJ;AD9sBI;EArwBF,iDAAA;EACA,oBAAA;ACs9CF;AD3sBI;EACE,oDAAA;AC6sBN;AD1sBI;EACE,qDAAA;AC4sBN;AFtuCE;EACE,wCAAA;EACA,sCAAA;EACA,cAAA;EACA,0CAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AEwuCJ;AFruCE;EACE,UAAA;AEuuCJ;;AFluCA;EACE,4BAAA;AEquCF;;AFhuCA;;EAEE,cAAA;EACA,kDAAA;EACA,YAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;AEmuCF;AFjuCE;;EACE,cAAA;AEouCJ;AFjuCE;;;EAEE,gBAAA;EACA,0CAAA;AEouCJ;;AF/tCA;;EAEE,SAAA;AEkuCF;;AF/tCA;EACE,sDAAA;EACA,oDAAA;EACA,+DAAA;EACA,8CAAA;AEkuCF;AFhuCE;EACE,sEAAA;EACA,qDAAA;AEkuCJ;AF/tCE;EACE,qEAAA;EACA,oDAAA;AEiuCJ;;AF7tCA;EACE,wDAAA;EACA,sDAAA;EACA,gEAAA;EACA,+CAAA;AEguCF;AF9tCE;EACE,uEAAA;EACA,sDAAA;AEguCJ;AF7tCE;EACE,sEAAA;EACA,qDAAA;AE+tCJ;;AFxtCI;;EACE,aAAA;AE4tCN;AFztCI;;EACE,aAAA;AE4tCN;;AFvtCA;EACE,yBAAA;EACA,wCAAA;EACA,wBAAA;EACA,sCAAA;AE0tCF;;AFltCE;;;;EACE,sBAAA;AEwtCJ;AFptCE;;;;EACE,wBAAA;EACA,wCAAA;AEytCJ;AFrtCE;;;;;;;;;;;;EAGE,yBAAA;AEguCJ;;AF1tCE;EACE,6BAAA;AE6tCJ;;AFvtCE;EACE,aAAA;AE0tCJ;;AFrtCE;EACE,eAAA;EACA,kBAAA;AEwtCJ;;AFntCE;EACE,kBAAA;AEstCJ;;AFjtCE;EACE,wBAAA;AEotCJ;;AF/sCE;EACE,0BAAA;EACA,wBAAA;AEktCJ;AF/sCE;EACE,yBAAA;AEitCJ;;AF5sCE;EACE,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;AE+sCJ;;AF1sCA;EACE,qGAAA;EACA,yFAAA;AE6sCF;;AF1sCA;EACE,6FAAA;AE6sCF;;AF1sCA;EACE,oGAAA;EACA,wFAAA;AE6sCF;;AF1sCA;EACE,4FAAA;AE6sCF;;AF1sCA;EACE,iGAAA;EACA,qFAAA;AE6sCF;;AF1sCA;EACE,yFAAA;AE6sCF;;AFzsCE;EACE,0CAAA;EACA,0CAAA;AE4sCJ;AF1sCI;EACE,8CAAA;EACA,+DAAA;AE4sCN;;AFtsCE;EACE,8CAAA;EACA,kEAAA;EACA,mDAAA;EACA,yBAAA;AEysCJ;;AAhrDE;EACE,8BAAA;EACA,6BAAA;EAEA,YAAA;EACA,WAAA;AAkrDJ;;AA7qDE;EACE,8BAAA;EACA,6BAAA;EAEA,gBAAA;AA+qDJ;;AAxqDE;;;EACE,8BAAA;EACA,6BAAA;EAEA,8BAAA;AA4qDJ;AA1qDI;;;EACE,4DAAA;AA8qDN;;AAvqDE;;EACE,sBAAA;AA2qDJ;AAzqDI;;EACE,oBAAA;AA4qDN;AAzqDI;;EACE,sBAAA;EACA,YAAA;EACA,WAAA;AA4qDN;AAzqDI;;EACE,uBAAA;EACA,uBAAA;AA4qDN;;AArqDI;EACE,uBAAA;EACA,uBAAA;AAwqDN;AArqDI;EACE,oBAAA;EACA,uBAAA;AAuqDN;;AAjqDE;EACE,sBAAA;AAoqDJ;AAlqDI;EACE,uBAAA;EACA,YAAA;EACA,WAAA;AAoqDN;AAlqDM;EACE,uBAAA;AAoqDR;AAjqDM;EACE,wBAAA;AAmqDR;AA/pDI;EACE,uBAAA;EACA,uBAAA;AAiqDN;;AA1pDI;EACE,wBAAA;EACA,YAAA;EACA,WAAA;AA6pDN;AA3pDM;EACE,wBAAA;AA6pDR;AAzpDI;EACE,uBAAA;EACA,uBAAA;AA2pDN;;AAtpDA;;EAEE,yBAAA;EACA,wBAAA;EAEA,gCAAA;EACA,8BAAA;AAwpDF;;AArpDA;EACE,mBAAA;EACA,8CAAA;EACA,aAAA;EACA,0CAAA;EACA,uBAAA;AAwpDF;AAtpDE;EACE,6BAAA;AAwpDJ;AAtpDI;EACE,sBAAA;EACA,yCAAA;EACA,2CAAA;AAwpDN;AArpDI;EACE,uBAAA;AAupDN;AAppDI;EACE,mDAAA;AAspDN;AAnpDI;EACE,mDAAA;EACA,oDAAA;AAqpDN;AAnpDM;EACE,eAAA;EACA,8CAAA;EACA,0CAAA;AAqpDR;AAjpDI;EACE,UAAA;EACA,yCAAA;EACA,2CAAA;AAmpDN;AA7oDE;EACE,SAAA;EACA,8BAAA;EACA,mEAAA;EACA,6BAAA;AA+oDJ;AA7oDI;EACE,8BAAA;AA+oDN;AA5oDI;EACE,gBAAA;AA8oDN;AAzoDI;EAEE,8CAAA;EACA,6CAAA;AA0oDN;AAvoDI;EACE,8CAAA;EACA,6CAAA;AAyoDN;AAtoDI;EACE,8CAAA;EACA,6CAAA;AAwoDN;AAroDI;EACE,8CAAA;EACA,6CAAA;AAuoDN;AApoDI;EAIE,8CAAA;AAmoDN;AA/nDE;EACE,8BAAA;AAioDJ;AA9nDE;EACE,4BAAA;AAgoDJ;AA9nDI;EACE,SAAA;AAgoDN;AA5nDE;EACE,6BAAA;AA8nDJ;AArnDE;EACE,mBAAA;AAunDJ","sourcesContent":["/**\n * Ids Button Component CSS\n * (Includes standard and icon button rules)\n */\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n@use './ids-button-base' as button;\n\n:host {\n  display: inline-flex;\n  vertical-align: middle;\n\n  ::slotted(span) {\n    vertical-align: bottom;\n  }\n\n  ::slotted(span),\n  ::slotted(ids-text) {\n    color: currentColor;\n    align-self: center;\n  }\n\n  ::slotted(ids-icon) {\n    vertical-align: middle;\n    color: currentColor;\n  }\n\n  ::slotted(ids-icon[compact='true']) {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  ::slotted(span.audible) {\n    @include mixins.audible();\n  }\n\n  // Button elements should fill the space inside shadow root\n  button,\n  .ids-icon-button {\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n  }\n}\n\n:host(.hidden) {\n  display: none;\n}\n\n:host([system-button]) {\n  button:not(.is-active):hover {\n    background-color: var(--ids-color-transparent);\n    border-color: var(--ids-color-transparent);\n    color: var(--ids-button-system-color-text-hover);\n  }\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n// Reset button display styles internally\nbutton {\n  display: block;\n}\n\n\n\n// Applies to all non-icon button types\n.ids-button,\n.ids-toggle-button,\n.ids-menu-button:not(.ids-icon-button),\n.ids-modal-button {\n  @include mixins.antialiased();\n\n  .ids-icon {\n    display: inline-flex;\n    place-self: center;\n    vertical-align: middle;\n  }\n}\n\n.ids-button,\n.ids-icon-button {\n  &.compact {\n    font-size: var(--ids-font-size-2xs);\n    height: var(--ids-button-compact-width);\n    line-height: 16px;\n  }\n}\n\n.ids-button.ellipsis {\n  ::slotted(span) {\n    display: block;\n    max-width: 100%;\n    overflow: hidden ;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: inherit;\n    height: inherit;\n  }\n}\n\n.ids-button,\n.ids-toggle-button,\n.ids-menu-button {\n  @include button.ids-base-button-styles();\n  @include button.ids-standard-button-colors();\n\n  // Assign padding based on type/usage\n  // ====================================================\n  &:not(.no-padding) {\n    @include button.ids-standard-button-padding();\n  }\n\n  &.btn-tertiary,\n  &.btn-tertiary-destructive {\n    @include button.ids-inline-button-padding();\n  }\n\n  &.no-padding {\n    @include button.ids-inline-button-padding();\n  }\n}\n\n.ids-menu-button.sub-tab-button.is-active {\n  background-color: unset;\n}\n\n.ids-menu-button.is-active,\n.ids-menu-button.is-active:hover {\n  background-color: var(--ids-button-menu-background-color-active);\n  color: var(--ids-button-menu-color-text-active);\n}\n\n.ids-menu-button.formatter-width {\n  &:not(.no-padding):not(.ids-icon-button) {\n    padding-inline-start: calc(var(--ids-space-xs) - 1px);\n    padding-inline-end: calc(var(--ids-space-xs) - 1px);\n  }\n\n  &:not(.formatter-width-percentage) {\n    justify-content: normal;\n\n    .ids-icon {\n      position: absolute;\n      inset-inline-end: var(--ids-space-2xs);\n    }\n  }\n}\n\n// Log button on masthead\n::slotted(ids-icon[icon='logo']) {\n  height: 30px;\n  opacity: 0.8;\n}\n\n.ids-icon-button {\n  @include button.ids-base-button-styles();\n  @include button.ids-standard-button-colors();\n\n  // Everything below is only for icon buttons\n  /* stylelint-disable-next-line no-duplicate-selectors */\n  & {\n    padding-inline-start: var(--ids-button-icon-padding);\n    padding-inline-end: var(--ids-button-icon-padding);\n    padding-block-start: var(--ids-button-icon-padding);\n    padding-block-end: var(--ids-button-icon-padding);\n  }\n\n  &:not(.no-padding):not(.sub-tab-button) {\n    padding-inline-start: var(--ids-button-icon-padding);\n    padding-inline-end:var(--ids-button-icon-padding);\n    padding-top: var(--ids-button-icon-padding);\n    padding-bottom: var(--ids-button-icon-padding);\n\n    &:not(.ids-trigger-button),\n    &:not(.compact)\n    &:not(.ids-sub-tab-close-button) {\n      height: var(--ids-button-icon-height);\n      width: var(--ids-button-icon-width);\n    }\n  }\n\n  &.sub-tab-button {\n    padding: 0;\n  }\n\n  &:not(.no-padding):not(.ids-trigger-button) {\n    &.compact {\n      height: calc(var(--ids-button-icon-compact-height) + 10px);\n      width: calc(var(--ids-button-icon-compact-width) + 8px);\n    }\n  }\n\n  &.compact {\n    padding-inline-start: calc(var(--ids-space-xs) + 1px);\n\n    &.gen-ai-active .loading-dots {\n      padding-inline-start: 1px;\n    }\n  }\n\n  &:not(.square) {\n    border-radius: var(--ids-button-radius);\n  }\n\n  &.square {\n    border-radius: var(--ids-border-radius-none);\n\n    &:hover {\n      ::slotted(ids-icon[icon='logo']) {\n        opacity: 1;\n      }\n    }\n  }\n\n  .ids-icon:not(.dropdown-icon) {\n    display: block;\n    padding-inline-start: var(--ids-space-3xs);\n    font-size: 0;\n    padding-block-start: var(--ids-space-3xs);\n  }\n\n  span.audible {\n    @include mixins.audible();\n  }\n\n  &.no-margins {\n    margin-inline-start: var(--ids-space-none);\n    margin-inline-end: var(--ids-space-none);\n  }\n}\n\n:host([field-height]) {\n  .ids-menu-button {\n    &.field-height-lg {\n      height: var(--ids-button-menu-field-height-lg);\n    }\n\n    &.field-height-md {\n      height: var(--ids-button-menu-field-height-md);\n    }\n\n    &.field-height-sm {\n      height: var(--ids-button-menu-field-height-sm);\n    }\n\n    &.field-height-xs {\n      height: var(--ids-button-menu-field-height-xs);\n    }\n  }\n}\n\n// Mix-in special rules for contextual buttons\n.ids-button,\n.ids-icon-button,\n.ids-menu-button {\n  @include button.ids-standard-button-shadows();\n}\n\n// Specific Modifications for Modal Buttons\n// Do not apply styles to modal close icon button, appearance as icon is required\n.ids-modal-button:not(.ids-modal-icon-button) {\n  @include button.ids-base-button-styles();\n  @include button.ids-modal-button-color-defaults();\n\n  /* stylelint-disable-next-line no-duplicate-selectors */\n  & {\n    padding-block-start: var(--ids-space-12);\n    padding-block-end: var(--ids-space-12);\n    display: block;\n    font-weight: var(--ids-font-weight-strong);\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n  }\n\n  &:focus {\n    z-index: 1;\n  }\n}\n\n// Adjusting hitbox for the modal close icon\n.ids-modal-icon-button {\n  padding: var(--ids-space-xs);\n}\n\n// ====================================================\n// Swipe Action Buttons (Swipe action component)\n.btn-swipe-action-left,\n.btn-swipe-action-right {\n  display: block;\n  padding: 0 var(--ids-space-xs) var(--ids-space-xs);\n  height: 100%;\n  margin: 0;\n  white-space: inherit;\n  width: 85px;\n\n  ::slotted(ids-icon) {\n    display: block;\n  }\n\n  &:hover,\n  &:focus {\n    box-shadow: none;\n    border-color: var(--ids-color-transparent);\n  }\n}\n\n// override button margin for swipe action buttons\n.ids-button:not(.no-margins).btn-swipe-action-left,\n.ids-button:not(.no-margins).btn-swipe-action-right {\n  margin: 0;\n}\n\n.btn-swipe-action-left {\n  border-start-end-radius: var(--ids-border-radius-none);\n  border-end-end-radius: var(--ids-border-radius-none);\n  background-color: var(--ids-swipe-action-color-background-left);\n  color: var(--ids-swipe-action-color-text-left);\n\n  &:active {\n    background-color: var(--ids-swipe-action-color-background-left-active);\n    color: var(--ids-swipe-action-color-text-left-active)\n  }\n\n  &:hover {\n    background-color: var(--ids-swipe-action-color-background-left-hover);\n    color: var(--ids-swipe-action-color-text-left-hover)\n  }\n}\n\n.btn-swipe-action-right {\n  border-start-start-radius: var(--ids-border-radius-none);\n  border-end-start-radius: var(--ids-border-radius-none);\n  background-color: var(--ids-swipe-action-color-background-right);\n  color: var(--ids-swipe-action-color-text-right);\n\n  &:active {\n    background-color: var(--ids-swipe-action-color-background-right-active);\n    color: var(--ids-swipe-action-color-text-right-active)\n  }\n\n  &:hover {\n    background-color: var(--ids-swipe-action-color-background-right-hover);\n    color: var(--ids-swipe-action-color-text-right-hover)\n  }\n}\n\n.ids-icon-button.gen-ai-active,\n.ids-button.gen-ai-active {\n  &:not(.no-animation) {\n    ::slotted(ids-icon[icon=\"genai\"]) {\n      display: none;\n    }\n\n    .loading-dots {\n      display: flex;\n    }\n  }\n}\n\n.ids-icon-button.gen-ai-active .loading-dots {\n  padding-inline-start: 3px;\n  padding-inline-end: var(--ids-space-3xs);\n  padding-block-start: 7px;\n  padding-block-end: var(--ids-space-xs);\n}\n\n// Applies to all non-icon button types\n.ids-button,\n.ids-toggle-button,\n.ids-menu-button:not(.ids-icon-button),\n.ids-modal-button:not(.ids-icon-button) {\n  ::slotted(ids-icon[icon=\"genai\"]:first-child) {\n    margin-inline-end: 5px;\n  }\n\n  // Padding rules for buttons that insert both text/icon into the fallback (unnamed) slot.\n  ::slotted(ids-icon:not(:first-child)) { // shadowroot + text + icon\n    margin-inline-start: 5px;\n    margin-inline-end: var( --ids-space-none);\n  }\n\n  // Padding rules for standalone CSS buttons (match the rules/style above)\n  .ids-icon:last-child,\n  span + span:not(.audible),\n  span:not(.audible):last-child {\n    padding-inline-start: 5px;\n  }\n}\n\n// Adjustment for about close icon\n.ids-modal-button {\n  ::slotted(ids-icon:not(:first-child)) { // shadowroot + text + icon\n    padding: var(--ids-space-3xs);\n  }\n}\n\n// Loading Indicator\n:host(:not([show-loading-indicator='true'])) {\n  ::slotted(.slot-loading-indicator) {\n    display: none;\n  }\n}\n\n:host([show-loading-indicator='true']) {\n  ::slotted(ids-loading-indicator) {\n    margin-top: 3px;\n    margin-bottom: 3px;\n  }\n}\n\n:host([show-loading-indicator='true'][loading-indicator-only='true']) {\n  ::slotted(*:not(.slot-loading-indicator)) {\n    visibility: hidden;\n  }\n}\n\n:host([show-loading-indicator='true']:not([loading-indicator-only='true'])) {\n  ::slotted(.slot-loading-indicator) {\n    margin-inline-start: 6px;\n  }\n}\n\n:host([show-loading-indicator='true']:not([loading-indicator-only='true']):is([appearance='primary'], [appearance='secondary'], [appearance='primary-destructive'])) {\n  &::part(button) {\n    padding-inline-start: 20px;\n    padding-inline-end: 12px;\n  }\n\n  ::slotted(.slot-loading-indicator) {\n    margin-inline-start: 10px;\n  }\n}\n\n:host([loading-indicator-only='true']) {\n  ::slotted(.slot-loading-indicator) {\n    position: absolute;\n    margin-inline-start: auto;\n    margin-inline-end: auto;\n    left: var(--ids-space-none);\n    right: var(--ids-space-none);\n  }\n}\n\n// Color effects on toggle button\n:host(ids-toggle-button:not(.dropdown-btn)) {\n  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-default);\n  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-default);\n}\n\n:host(ids-toggle-button[pressed]) {\n  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-default);\n}\n\n:host(ids-toggle-button[color='orange']) {\n  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-orange);\n  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-orange);\n}\n\n:host(ids-toggle-button[pressed][color='orange']) {\n  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-orange);\n}\n\n:host(ids-toggle-button[color='red']) {\n  --ids-button-tertiary-color-background-hover: var(--ids-button-toggle-color-background-hover-red);\n  --ids-button-tertiary-color-text-hover: var(--ids-button-toggle-color-text-hover-red);\n}\n\n:host(ids-toggle-button[pressed][color='red']) {\n  --ids-button-tertiary-color-text-default: var(--ids-button-toggle-color-text-pressed-red);\n}\n\n:host(ids-toggle-button.ids-toggle-button-segmented) {\n  button {\n    border-radius: var(--ids-border-radius-sm);\n    font-weight: var(--ids-font-weight-normal);\n\n    &:hover {\n      color: var(--ids-segmented-control-text-color);\n      background-color: var(--ids-segmented-control-background-hover);\n    }\n  }\n}\n\n:host(ids-toggle-button.ids-toggle-button-segmented[pressed]) {\n  button {\n    color: var(--ids-segmented-control-text-color);\n    background-color: var(--ids-segmented-control-background-selected);\n    box-shadow: var(--ids-segmented-control-box-shadow);\n    border-color: transparent;\n  }\n}\n","/**\n * Ids Button Sass mixins, used in Ids Button CSS to define base styles.\n */\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n// Mixin for a \"blank\" shadow (same as the standard one with a completely transparent alpha)\n@mixin blank-shadow() {\n  box-shadow: var(--ids-shadow-none);\n}\n\n// Used to make the focus \"border\" appear to be separated from the button (primary/secondary types).\n@mixin outset-button-shadow($bg-color, $border-color) {\n  box-shadow:\n    0 0 0 2px $bg-color, // bg color\n    0 0 0 3px $border-color\n}\n\n// Used to make the focus \"border\" on non-solid buttons (modal buttons, etc)\n@mixin modal-button-shadow() {\n  outline: 1px solid var(--ids-modal-color-outline);\n  outline-offset: -1px;\n}\n\n@mixin alternate-button-shadow() {\n  box-shadow: var(--ids-box-shadow-inverse);\n}\n\n// Used to include a basic set of button styles within each individual button prototype.\n@mixin ids-base-button-styles() {\n  @include blank-shadow();\n\n  font-weight: var(--ids-font-weight-normal);\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  font-size: var(--ids-font-size-sm);\n  overflow: hidden;\n  padding-bottom: calc(var(--ids-space-xs) - 2px);\n  padding-top: calc(var(--ids-space-xs) - 2px);\n  position: relative;\n\n  &,\n  &::before,\n  &::after {\n    box-sizing: border-box;\n  }\n\n  // Nothing inside the button itself should accept mouse events\n  * {\n    pointer-events: none;\n  }\n\n  // ====================================================\n  // Base Button styles (default/tertiary)\n\n  & {\n    border: 1px solid transparent;\n    background-color: var(--ids-color-transparent);\n    color: var(--ids-button-color-text-default);\n\n    // Animate BG/Text/Border color changes on all styles\n    transition:\n      background-color var(--ids-motion-duration) var(--ids-motion-ease),\n      border-color var(--ids-motion-duration) var(--ids-motion-ease),\n      color var(--ids-motion-duration) var(--ids-motion-ease),\n      opacity var(--ids-motion-duration) var(--ids-motion-ease);\n    white-space: nowrap;\n  }\n\n  &:focus {\n    // Disable standard focus state in Chrome\n    outline: none;\n    outline-color: var(--ids-color-transparent);\n  }\n\n  &:not([disabled]) {\n   cursor: var(--ids-cursor-pointer);\n  }\n\n  // ====================================================\n  // Standard element types inside the button\n  span {\n    vertical-align: bottom;\n\n    &.audible {\n      @include mixins.audible();\n    }\n  }\n\n  &:not(.color-variant-module-nav):not(.ids-icon-button):not(.align-icon-end):not(.compact) ::slotted(ids-icon:not([icon='genai'])) {\n    margin-inline-end: calc(var(--ids-space-2xs) + 3px);\n  }\n\n  .ids-icon {\n    vertical-align: middle;\n  }\n\n  // ====================================================\n  // Alignment changes\n\n  &.align-icon-end {\n    ::slotted(ids-icon) {\n      margin-inline-start: var(--ids-space-2xs);\n    }\n  }\n\n  &.content-align-start {\n    justify-content: start;\n  }\n\n  &.content-align-end {\n    justify-content: end;\n  }\n\n  &.no-margins {\n    margin-inline: var(--ids-space-none);\n  }\n\n  &.field-height-xxs:not(.btn-secondary):not(.no-margins) {\n    margin-block-start: 3px;\n    margin-inline-end: -2px;\n    height: 22px;\n    width: 22px;\n  }\n\n  ::slotted(span) {\n    // important due to reset in enterprise\n    font-weight: inherit !important;\n  }\n}\n\n/**\n * Provides standardized padding rules for certain button types\n */\n@mixin ids-standard-button-padding() {\n  padding-inline: var(--ids-button-padding-inline);\n}\n\n@mixin ids-inline-button-padding() {\n  padding-inline: var(--ids-space-12);\n}\n\n/**\n * Provides the standard color rules for all regular buttons\n */\n@mixin ids-standard-button-colors() {\n  & {\n    display: inline-flex;\n    font-weight: var(--ids-button-tertiary-font-weight);\n    border-radius: var(--ids-button-radius);\n\n    // ====================================================\n    // Default/Tertiary Button\n    background-color: var(--ids-button-tertiary-color-background-default);\n    border-color: var(--ids-button-tertiary-color-border-default);\n    color: var(--ids-button-tertiary-color-text-default);\n  }\n\n  &:not(.hide-focus).is-active,\n  &:not(.hide-focus).is-focused,\n  &:not(.hide-focus):focus,\n  &:not(.hide-focus):focus-within {\n    &:not([readonly]) {\n      border-color: var(--ids-button-tertiary-color-border-focus);\n    }\n  }\n\n  &:hover {\n    color: var(--ids-button-tertiary-color-text-hover);\n    background-color: var(--ids-button-tertiary-color-background-hover);\n    border-color: var(--ids-button-tertiary-color-border-hover);\n  }\n\n  &[disabled] {\n    color: var(--ids-button-tertiary-color-text-disabled);\n    background-color: var(--ids-button-tertiary-color-background-disabled);\n    border-color: var(--ids-button-tertiary-color-border-disabled);\n    opacity: var(--ids-button-tertiary-opacity-disabled);\n  }\n\n  &:active:not([disabled]) {\n    background-color: var(--ids-button-tertiary-color-background-pressed);\n    border-color: var(--ids-button-tertiary-color-border-pressed);\n    color: var(--ids-button-tertiary-color-text-pressed);\n  }\n\n  // ====================================================\n  // Tertiary Destructive Button\n  &.btn-tertiary-destructive {\n    background-color: var(--ids-button-destructive-tertiary-color-background-default);\n    border-color: var(--ids-button-destructive-tertiary-color-border-default);\n    color: var(--ids-button-destructive-tertiary-color-text-default);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      border-color: var(--ids-button-destructive-tertiary-color-border-focus);\n    }\n\n    &:hover {\n      background-color: var(--ids-button-destructive-tertiary-color-background-hover);\n      border-color: var(--ids-button-destructive-tertiary-color-border-hover);\n      color: var(--ids-button-destructive-tertiary-color-text-hover);\n    }\n\n    &[disabled] {\n      color: var(--ids-button-destructive-tertiary-color-text-disabled);\n      background-color: var(--ids-button-destructive-tertiary-color-background-disabled);\n      border-color: var(--ids-button-destructive-tertiary-color-border-disabled);\n    }\n  }\n\n  // ====================================================\n  // Primary Button\n\n  &.btn-primary {\n    background-color: var(--ids-button-primary-color-background-default);\n    border-color: var(--ids-button-primary-color-border-default);\n    border: 1px solid var(--ids-button-primary-color-border-default);\n    color: var(--ids-button-primary-color-text-default);\n    padding-bottom: calc(var(--ids-space-xs) - 2px);\n    padding-top: calc(var(--ids-space-xs) - 2px);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      border-color: var(--ids-button-primary-color-border-focus);\n    }\n\n    &:hover {\n      background-color: var(--ids-button-primary-color-background-hover);\n      border-color: var(--ids-button-primary-color-border-hover);\n    }\n\n    &[disabled] {\n      background-color: var(--ids-button-primary-color-background-disabled);\n      border-color: var(--ids-button-primary-color-border-disabled);\n      color: var(--ids-button-primary-color-text-disabled);\n      opacity: var(--ids-button-primary-opacity-disabled);\n    }\n\n    &:active:not([disabled]) {\n      background-color: var(--ids-button-primary-color-background-pressed);\n      border-color: var(--ids-button-primary-color-border-pressed);\n      color: var(--ids-button-primary-color-text-pressed);\n    }\n  }\n\n  // ====================================================\n  // Primary Destructive Button\n\n  &.btn-primary-destructive {\n    background-color: var(--ids-button-destructive-color-background-default);\n    border-color: var(--ids-button-destructive-color-border-default);\n    color: var(--ids-button-destructive-color-text-default);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      border-color: var(--ids-button-destructive-color-border-focus);\n    }\n\n    &:hover {\n      background-color: var(--ids-button-destructive-color-background-hover);\n      border-color: var(--ids-button-destructive-color-border-hover);\n      color: var(--ids-button-destructive-color-text-hover);\n    }\n\n    &[disabled] {\n      background-color: var(--ids-button-destructive-color-background-disabled);\n      border-color: var(--ids-button-destructive-color-border-disabled);\n      color: var(--ids-button-destructive-color-text-disabled);\n      opacity: var(--ids-button-destructive-opacity-disabled);\n    }\n  }\n\n  // ====================================================\n  // Primary Generative AI Button\n  @keyframes dot-flashing {\n    0% {\n      background-color: var(--ids-button-ai-color-loading-dot-primary-step-1);\n    }\n\n    50%,\n    100% {\n        background-color: var(--ids-button-ai-color-loading-dot-primary-step-2);\n    }\n  }\n\n  @keyframes dot-flashing-colors-secondary {\n    0% {\n      background-color: var(--ids-button-ai-color-loading-dot-secondary-step-1);\n    }\n\n    50%,\n    100% {\n        background-color: var(--ids-button-ai-color-loading-dot-secondary-step-2)\n    }\n  }\n\n  @keyframes dot-flashing-colors-tertiary {\n    0% {\n      background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-1);\n    }\n\n    50%,\n    100% {\n        background-color: var(--ids-button-ai-color-loading-dot-tertiary-step-2)\n    }\n  }\n\n  .loading-dots-start {\n    padding-inline-start: 3px !important;\n    padding-inline-end: 7px !important;\n    gap: 2px;\n  }\n\n  .loading-dots {\n    display: none;\n    position: relative;\n    flex-direction: row;\n    gap: 2px;\n    padding-inline-start: 7px;\n    padding-inline-end: 3px;\n\n    .dot {\n      display: inline-flex;\n      position: relative;\n      width: 3px;\n      height: 3px;\n      border-radius: 5px;\n      background-color: var(--ids-button-ai-color-loading-dot-default);\n      color:  var(--ids-button-ai-color-loading-dot-default);\n    }\n  }\n\n  &.btn-primary-generative-ai {\n    --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-primary-sparkle-icon-color-fill);\n\n    background: border-box var(--ids-button-ai-color-background-default);\n    border: none;\n    color: var(--ids-button-ai-color-text-default);\n    align-items: center;\n    min-width: 34px;\n    min-height: 34px;\n\n    &.compact {\n      min-width: var(--ids-button-compact-width);\n      min-height: var(--ids-button-compact-width);\n    }\n\n    &:hover {\n      background: border-box var(--ids-button-ai-color-background-hover);\n    }\n\n    &:active,\n    &.gen-ai-active {\n      background: border-box var(--ids-button-ai-color-background-active);\n      color: var(--ids-button-ai-color-text-active);\n    }\n\n    &[disabled] {\n      background: border-box var(--ids-button-ai-color-background-disabled);\n    }\n\n    &.color-variant-alternate-formatter,\n    &.color-variant-alternate-formatter:hover {\n      color: var(--ids-color-white-100);\n      min-height: var(--ids-button-formatter-size);\n      min-width: 34px;\n    }\n\n    .loading-dots {\n      .dot:nth-child(1) {\n        animation: dot-flashing 1s infinite alternate;\n        animation-delay: 0s;\n      }\n\n      .dot:nth-child(2) {\n        animation: dot-flashing 1s infinite linear alternate;\n        animation-delay: 0.5s;\n      }\n\n      .dot:nth-child(3) {\n        animation: dot-flashing 1s infinite alternate;\n        animation-delay: 1s;\n      }\n    }\n  }\n\n  // ====================================================\n  // Secondary Generative Button\n  &.btn-secondary-generative-ai {\n    --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-secondary-sparkle-icon-color-fill);\n\n    background: var(--ids-button-ai-secondary-color-background-default);\n    border: 1px solid var(--ids-button-ai-secondary-color-border-default);\n    color: var(--ids-button-ai-secondary-color-default);\n    align-items: center;\n\n    &:hover:not([disabled]) {\n      background: var(--ids-button-ai-secondary-color-background-hover);\n      color: var(--ids-button-ai-secondary-color-hover);\n      border-color: var(--ids-button-ai-secondary-color-border-hover);\n    }\n\n    &:active:not([disabled]) {\n      background: var(--ids-button-ai-secondary-color-background-active);\n      color: var(--ids-button-ai-secondary-color-active);\n      border-color: var(--ids-button-ai-secondary-color-border-active);\n    }\n\n    ::slotted(ids-icon[icon=\"genai\"]) {\n      --ids-button-ai-color-icon-primary: var(--ids-button-ai-color-icon-primary-hover);\n      --ids-button-ai-color-icon-secondary: var(--ids-button-ai-color-icon-secondary-hover);\n    }\n\n    &.gen-ai-active {\n      background: var(--ids-button-ai-secondary-color-background-active);\n    }\n\n    &[disabled] {\n      opacity: var(--ids-button-ai-opacity-disabled);\n    }\n\n    // Loading dots animation\n    .loading-dots {\n      .dot {\n        background-color: var(--ids-button-ai-color-loading-dot-secondary);\n        color: var(--ids-button-ai-color-loading-dot-secondary);\n      }\n\n      .dot:nth-child(1) {\n        animation: dot-flashing-colors-secondary 1s infinite alternate;\n        animation-delay: 0s;\n      }\n\n      .dot:nth-child(2) {\n        animation: dot-flashing-colors-secondary 1s infinite linear alternate;\n        animation-delay: 0.5s;\n      }\n\n      .dot:nth-child(3) {\n        animation: dot-flashing-colors-secondary 1s infinite alternate;\n        animation-delay: 1s;\n      }\n    }\n  }\n\n  // ====================================================\n  // Tertiary Generative Button\n  &.btn-tertiary-generative-ai {\n    --ids-button-tertiary-ai-shadow-focus: var(--ids-button-tertiary-shadow-focus);\n    --ids-button-ai-color-icon-secondary-hover: var(--ids-color-action-stronger);\n    --ids-button-ai-sparkle-icon-color-fill: var(--ids-button-ai-tertiary-sparkle-icon-color-fill);\n\n    background: var(--ids-button-ai-tertiary-color-background-default);\n    background-clip: text;\n    align-items: center;\n    color: var(--ids-button-ai-tertiary-color-text-default);\n\n    &:hover {\n      background: var(--ids-button-ai-tertiary-color-background-hover);\n    }\n\n    ::slotted(ids-icon[icon=\"genai\"]) {\n      --ids-button-ai-color-icon-primary: var(--ids-button-ai-tertiary-color-text-default);\n      --ids-button-ai-color-icon-secondary: var(--ids-button-ai-tertiary-color-text-default);\n    }\n\n    &:active,\n    &.gen-ai-active {\n      background: var(--ids-button-ai-tertiary-color-background-active);\n    }\n\n    &[disabled] {\n      background: var(--ids-button-tertiary-ai-color-background-disabled);\n      opacity: var(--ids-button-ai-opacity-disabled);\n    }\n\n    // Loading dots animation\n    .loading-dots {\n      .dot:nth-child(1) {\n        animation: dot-flashing-colors-tertiary 1s infinite alternate;\n        animation-delay: 0s;\n      }\n\n      .dot:nth-child(2) {\n        animation: dot-flashing-colors-tertiary 1s infinite linear alternate;\n        animation-delay: 0.5s;\n      }\n\n      .dot:nth-child(3) {\n        animation: dot-flashing-colors-tertiary 1s infinite alternate;\n        animation-delay: 1s;\n      }\n    }\n  }\n\n  // ====================================================\n  // Secondary Button\n  &.btn-secondary {\n    background-color: var(--ids-button-secondary-color-background-default);\n    border-width: var(--ids-button-secondary-border-width);\n    border-color: var(--ids-button-secondary-color-border-default);\n    color: var(--ids-button-secondary-color-text-default);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      background-color: var(--ids-button-secondary-color-background-focus);\n      border-color: var(--ids-button-secondary-color-border-focus);\n    }\n\n    &:hover:not([disabled]) {\n      background-color: var(--ids-button-secondary-color-background-hover);\n      border-color: var(--ids-button-secondary-color-border-hover);\n      color: var(--ids-button-secondary-color-text-hover);\n    }\n\n    &[disabled] {\n      background-color: var(--ids-button-secondary-color-background-disabled);\n      border-color: var(--ids-button-secondary-color-border-disabled);\n      color: var(--ids-button-secondary-color-text-disabled);\n      opacity: var(--ids-button-secondary-opacity-disabled);\n    }\n\n    &:active:not([disabled]) {\n      background-color: var(--ids-button-secondary-color-background-pressed);\n      border-color: var(--ids-button-secondary-color-border-pressed);\n      color: var(--ids-button-secondary-color-text-pressed);\n    }\n  }\n\n  // ====================================================\n  // Light Mode Alternate\n\n  // Don't apply these rules to \"alternate-formatter\"-style buttons\n  // These appear in header\n  &.color-variant-alternate {\n    &:hover {\n      background-color: rgb(0 0 0 / 0.3);\n    }\n\n    &.ids-trigger-button:not([readonly]) {\n      &:hover {\n        background-color: var(--ids-search-field-header-color-icon-hover);\n      }\n    }\n  }\n\n  // These appear in app menu\n  &.color-variant-app-menu {\n    &:hover {\n      background-color: rgb(255 255 255 / 0.15);\n    }\n  }\n\n  // These appear in places with dark background like app menu and masthead, generally default/tertiary buttons\n  &.color-variant-alternate,\n  &.color-variant-alternate-formatter {\n    color: var(--ids-button-alternate-color-text-default);\n    opacity: 0.8;\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      border-color: var(--ids-button-formatter-color-border-focus);\n      opacity: 1;\n    }\n\n    &:hover {\n      background-color: var(--ids-button-formatter-color-background-hover);\n      border-color: var(--ids-color-transparent);\n      color: var(--ids-button-formatter-color-text-hover);\n      opacity: 1;\n    }\n\n    &[disabled] {\n      background-color: var(--ids-color-transparent);\n      opacity: var(--ids-button-formatter-opacity-disabled);\n    }\n  }\n\n  // Used on Editor and List Builder \"darker\" toolbars\n  &.color-variant-alternate-formatter {\n    background-color: var(--ids-button-formatter-color-background-default);\n    border-color: var(--ids-button-formatter-color-border-default);\n    color: var(--ids-button-formatter-color-text-default);\n    height: var(--ids-button-formatter-size);\n    min-width: var(--ids-button-formatter-size);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      border-color: var(--ids-color-border-focus);\n    }\n\n    &[disabled] {\n      color: var(--ids-button-formatter-color-text-disabled);\n    }\n\n    &:hover {\n      background-color: var(--ids-button-formatter-color-background-hover);\n      color: var(--ids-button-formatter-color-text-hover);\n    }\n\n    &.is-active {\n      color: var(--ids-button-formatter-color-active);\n    }\n\n    &.ids-menu-button.compact {\n      padding: var(--ids-space-2xs);\n      padding-inline: var(--ids-space-2xs);\n\n      &.square {\n        border-radius: var(--ids-border-radius-xs);\n        width: 34px;\n      }\n    }\n\n    &[editor-action='sourcemode'],\n    &[editor-action='editormode'] {\n      --ids-button-icon-width: 54px;\n    }\n  }\n\n  // Used in Tab Module Variant\n  &.color-variant-module {\n    border: 0;\n    color: var(--ids-button-module-color-text-default);\n\n    &:not(.square) {\n      border-radius: var(--ids-button-module-border-radius);\n    }\n\n    &:hover {\n      background-color: var(--ids-button-module-color-background-hover);\n      color: var(--ids-button-module-color-text-hover);\n    }\n  }\n}\n\n/**\n * Provides the standard color rules for buttons that need box shadow\n */\n@mixin ids-standard-button-shadows() {\n  &:not(.btn-primary):not(.btn-secondary):not(.btn-primary-destructive):not(.btn-tertiary-destructive):not(.btn-primary-generative-ai):not(.btn-secondary-generative-ai):not(.btn-tertiary-generative-ai) {\n    // ====================================================\n    // Default/Tertiary Default/Light Mode\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      &:not([readonly]) {\n        box-shadow: var(--ids-button-tertiary-shadow-focus);\n      }\n    }\n\n    &.color-variant-alternate {\n      &:not(.hide-focus).is-active,\n      &:not(.hide-focus).is-focused,\n      &:not(.hide-focus).focus-within,\n      &:not(.hide-focus):focus {\n        box-shadow: var(--ids-box-shadow-inverse);\n      }\n    }\n\n    &.color-variant-alternate-formatter {\n      &:not(.hide-focus).is-active,\n      &:not(.hide-focus).is-focused,\n      &:not(.hide-focus).focus-within,\n      &:not(.hide-focus):focus {\n        box-shadow: var(--ids-shadow-20);\n      }\n    }\n  }\n\n  &.btn-tertiary-destructive {\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      box-shadow: var(--ids-button-destructive-tertiary-shadow-focus);\n    }\n  }\n\n  &.btn-primary {\n    // ====================================================\n    // Primary Default/Light Mode\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      box-shadow: var(--ids-button-primary-shadow-focus);\n    }\n\n    &.color-variant-alternate {\n      &:not(.hide-focus).is-active,\n      &:not(.hide-focus).is-focused,\n      &:not(.hide-focus).focus-within,\n      &:not(.hide-focus):focus {\n        @include outset-button-shadow(\n          var(--ids-color-primary-70),\n          var(--ids-color-text-on-primary)\n        );\n      }\n    }\n  }\n\n  &.btn-primary-destructive {\n    // ====================================================\n    // Primary Destructive Default/Light Mode\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      @include outset-button-shadow(\n        var(--ids-color-background-default),\n        var(--ids-color-error-default)\n      );\n    }\n  }\n\n  &.btn-secondary {\n    // ====================================================\n    // Secondary Default/Light Mode\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      box-shadow: var(--ids-button-secondary-shadow-focus);\n    }\n  }\n\n  &.btn-primary-generative-ai {\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      box-shadow: var(--ids-button-ai-shadow-focus);\n      border-color: var(--ids-color-transparent);\n    }\n  }\n\n  &.btn-tertiary-generative-ai,\n  &.btn-secondary-generative-ai {\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      box-shadow: var(--ids-button-tertiary-ai-shadow-focus);\n      border-color: var(--ids-button-ai-color-icon-secondary-hover);\n    }\n  }\n}\n\n@mixin ids-modal-button-color-defaults() {\n  // ====================================================\n  // Primary Button\n  &.btn-primary {\n    background-color: var(--ids-modal-color-background);\n    color: var(--ids-modal-button-color-default);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      @include modal-button-shadow();\n    }\n\n    &:hover:not([disabled]) {\n      color: var(--ids-modal-button-color-hover);\n    }\n\n    &[disabled] {\n      opacity: var(--ids-button-primary-opacity-disabled);\n    }\n  }\n\n  // ====================================================\n  // Secondary/Tertiary Button\n\n  &.btn-secondary,\n  &.btn-tertiary {\n    background-color: var(--ids-modal-color-background);\n    color: var(--ids-modal-button-secondary-color-default);\n\n    &:not(.hide-focus).is-active,\n    &:not(.hide-focus).is-focused,\n    &:not(.hide-focus).focus-within,\n    &:not(.hide-focus):focus {\n      @include modal-button-shadow();\n    }\n\n    &:hover {\n      color: var(--ids-modal-button-secondary-color-hover);\n    }\n\n    &[disabled] {\n      opacity:var(--ids-button-secondary-opacity-disabled);\n    }\n  }\n}\n","@use '../ids-button/ids-button' as *;\n\n:host {\n  button {\n    --ids-button-icon-height: 32px;\n    --ids-button-icon-width: 32px;\n\n    height: auto;\n    width: auto;\n  }\n}\n\n:host(.expand-button) {\n  button {\n    --ids-button-icon-height: 34px;\n    --ids-button-icon-width: 34px;\n\n    margin-top: -2px;\n  }\n}\n\n:host([compact]),\n:host([field-height='xs']),\n:host([field-height='sm']) {\n  .ids-trigger-button.ids-icon-button {\n    --ids-button-icon-height: 26px;\n    --ids-button-icon-width: 26px;\n\n    padding: var(--ids-space-none);\n\n    &:not(.square) {\n      border-radius: var(--ids-trigger-field-button-border-radius);\n    }\n  }\n}\n\n:host([field-height='xs']),\n:host([field-height='xxs']) {\n  .ids-trigger-button.ids-icon-button {\n    margin-inline-end: 3px;\n\n    &.color-variant-borderless[aria-label='DropdownTriggerButton'] {\n      margin-inline-end: 0;\n    }\n\n    &.color-variant-borderless {\n      margin-inline-end: 3px;\n      height: 22px;\n      width: 22px;\n    }\n\n    &.color-variant-in-cell {\n      margin-inline-end: -3px;\n      margin-block-start: 2px;\n    }\n  }\n}\n\n:host([field-height='xxs']) {\n  .ids-trigger-button.ids-icon-button {\n    &.color-variant-borderless[aria-label='DropdownTriggerButton'] {\n      margin-inline-end: -1px;\n      margin-block-start: 3px;\n    }\n\n    &.color-variant-in-cell {\n      margin-inline-end: 0;\n      margin-block-start: 2px;\n    }\n  }\n}\n\n:host([field-height='sm']) {\n  .ids-trigger-button.ids-icon-button {\n    margin-inline-end: 2px;\n\n    &.color-variant-borderless {\n      margin-inline-end: -2px;\n      height: 24px;\n      width: 24px;\n\n      &[aria-label='DropdownTriggerButton'] {\n        margin-inline-end: -4px;\n      }\n\n      &.no-margins {\n        margin-inline-start: 2px;\n      }\n    }\n\n    &.color-variant-in-cell {\n      margin-inline-end: -3px;\n      margin-block-start: 1px;\n    }\n  }\n}\n\n:host([field-height='md']) {\n  .ids-trigger-button.ids-icon-button {\n    &.color-variant-borderless {\n      margin-inline-end: -11px;\n      height: 30px;\n      width: 30px;\n\n      &.no-margins {\n        margin-inline-start: 2px;\n      }\n    }\n\n    &.color-variant-in-cell {\n      margin-inline-end: -4px;\n      margin-block-start: 1px;\n    }\n  }\n}\n\n:host(.expand-button),\n.expand-button {\n  --ids-button-height: 36px;\n  --ids-button-width: 36px;\n\n  height: var(--ids-button-height);\n  width: var(--ids-button-width);\n}\n\n.ids-trigger-button {\n  align-items: center;\n  background-color: var(--ids-color-transparent);\n  display: flex;\n  color: var(--ids-trigger-field-icon-color);\n  justify-content: center;\n\n  &.ids-icon-button {\n    padding: var(--ids-space-2xs);\n\n    &.ids-sub-tab-close-button {\n      margin-inline-end: 3px;\n      width: var(--ids-button-icon-third-width);\n      height: var(--ids-button-icon-third-height);\n    }\n\n    &:not(.ids-tab-close-button):not(.ids-sub-tab-close-button) {\n      inset-inline-start: 2px;\n    }\n\n    &[disabled] {\n      color: var(--ids-trigger-field-color-text-disabled);\n    }\n\n    &[readonly] {\n      color: var(--ids-trigger-field-color-text-disabled);\n      opacity: var(--ids-button-tertiary-opacity-disabled);\n\n      &:hover {\n        cursor: default;\n        background-color: var(--ids-color-transparent);\n        border-color: var(--ids-color-transparent);\n      }\n    }\n\n    &.ids-tab-close-button:not(.no-padding):not(.sub-tab-button):not(.compact) {\n      padding: 0;\n      width: var(--ids-button-icon-third-width);\n      height: var(--ids-button-icon-third-height);\n    }\n  }\n\n  // ===================================================\n  // Inline Style: Show a border on the trigger button's inner-edge\n  &.style-inline {\n    border: 0;\n    padding: var(--ids-space-none);\n    border-radius: var(--ids-trigger-field-button-border-radius-inline);\n    margin: var(--ids-space-none);\n\n    &.ids-icon-button {\n      padding: var(--ids-space-none);\n    }\n\n    &.square {\n      border-radius: 0;\n    }\n\n    // ===================================================\n    // Field Heights\n    &.field-height-xs,\n    &.field-height-xs.compact {\n      height: calc(var(--ids-input-height-10) - 2px);\n      width: calc(var(--ids-input-height-10) - 2px);\n    }\n\n    &.field-height-sm {\n      height: calc(var(--ids-input-height-20) - 2px);\n      width: calc(var(--ids-input-height-20) - 2px);\n    }\n\n    &.field-height-md {\n      height: calc(var(--ids-input-height-30) - 2px);\n      width: calc(var(--ids-input-height-30) - 2px);\n    }\n\n    &.field-height-lg {\n      height: calc(var(--ids-input-height-40) - 2px);\n      width: calc(var(--ids-input-height-40) - 2px);\n    }\n\n    &.compact,\n    &.field-height-sm.compact,\n    &.field-height-md.compact,\n    &.field-height-lg.compact {\n      height: calc(var(--ids-input-height-10) - 2px);\n    }\n  }\n\n  &.inline-end {\n    border-inline-start: 1px solid;\n  }\n\n  &.inline-start {\n    border-inline-end: 1px solid;\n\n    &:not(.btn-secondary):not(.no-margins) {\n      margin: 0;\n    }\n  }\n\n  &.color-variant-alternate-formatter {\n    padding: var(--ids-space-3xs);\n  }\n\n  // ===================================================\n  // Inherit Color setting\n  // Reset themed button colors on Trigger Buttons,\n  // which are presumably slotted into another component\n  // that should inherit colors from its parent.\n\n  &.inherit-color {\n    color: currentColor;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 1440px;\n$breakpoint-xl: 1280px;\n$breakpoint-lg: 1024px;\n$breakpoint-md: 840px;\n$breakpoint-sm: 600px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
